webpackJsonp([7132574359420],{

/***/ 64:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(65);

/***/ }),

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var settle = __webpack_require__(71);
	var buildURL = __webpack_require__(74);
	var parseHeaders = __webpack_require__(80);
	var isURLSameOrigin = __webpack_require__(78);
	var createError = __webpack_require__(28);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(73);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(76);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),

/***/ 65:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var bind = __webpack_require__(29);
	var Axios = __webpack_require__(67);
	var defaults = __webpack_require__(14);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(26);
	axios.CancelToken = __webpack_require__(66);
	axios.isCancel = __webpack_require__(27);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(81);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),

/***/ 26:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(26);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),

/***/ 67:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(14);
	var utils = __webpack_require__(2);
	var InterceptorManager = __webpack_require__(68);
	var dispatchRequest = __webpack_require__(69);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(70);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),

/***/ 69:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	var transformData = __webpack_require__(72);
	var isCancel = __webpack_require__(27);
	var defaults = __webpack_require__(14);
	var isAbsoluteURL = __webpack_require__(77);
	var combineURLs = __webpack_require__(75);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),

/***/ 70:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(28);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(2);
	var normalizeHeaderName = __webpack_require__(79);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(25);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(25);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),

/***/ 29:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),

/***/ 73:
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),

/***/ 74:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),

/***/ 75:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),

/***/ 77:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),

/***/ 80:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(2);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),

/***/ 81:
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(29);
	var isBuffer = __webpack_require__(91);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

	/* flatpickr v4.5.2, @license MIT */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.flatpickr = factory());
	}(this, (function () { 'use strict';
	
	    var pad = function pad(number) {
	      return ("0" + number).slice(-2);
	    };
	    var int = function int(bool) {
	      return bool === true ? 1 : 0;
	    };
	    function debounce(func, wait, immediate) {
	      if (immediate === void 0) {
	        immediate = false;
	      }
	
	      var timeout;
	      return function () {
	        var context = this,
	            args = arguments;
	        timeout !== null && clearTimeout(timeout);
	        timeout = window.setTimeout(function () {
	          timeout = null;
	          if (!immediate) func.apply(context, args);
	        }, wait);
	        if (immediate && !timeout) func.apply(context, args);
	      };
	    }
	    var arrayify = function arrayify(obj) {
	      return obj instanceof Array ? obj : [obj];
	    };
	
	    var do_nothing = function do_nothing() {
	      return undefined;
	    };
	
	    var monthToStr = function monthToStr(monthNumber, shorthand, locale) {
	      return locale.months[shorthand ? "shorthand" : "longhand"][monthNumber];
	    };
	    var revFormat = {
	      D: do_nothing,
	      F: function F(dateObj, monthName, locale) {
	        dateObj.setMonth(locale.months.longhand.indexOf(monthName));
	      },
	      G: function G(dateObj, hour) {
	        dateObj.setHours(parseFloat(hour));
	      },
	      H: function H(dateObj, hour) {
	        dateObj.setHours(parseFloat(hour));
	      },
	      J: function J(dateObj, day) {
	        dateObj.setDate(parseFloat(day));
	      },
	      K: function K(dateObj, amPM, locale) {
	        dateObj.setHours(dateObj.getHours() % 12 + 12 * int(new RegExp(locale.amPM[1], "i").test(amPM)));
	      },
	      M: function M(dateObj, shortMonth, locale) {
	        dateObj.setMonth(locale.months.shorthand.indexOf(shortMonth));
	      },
	      S: function S(dateObj, seconds) {
	        dateObj.setSeconds(parseFloat(seconds));
	      },
	      U: function U(_, unixSeconds) {
	        return new Date(parseFloat(unixSeconds) * 1000);
	      },
	      W: function W(dateObj, weekNum) {
	        var weekNumber = parseInt(weekNum);
	        return new Date(dateObj.getFullYear(), 0, 2 + (weekNumber - 1) * 7, 0, 0, 0, 0);
	      },
	      Y: function Y(dateObj, year) {
	        dateObj.setFullYear(parseFloat(year));
	      },
	      Z: function Z(_, ISODate) {
	        return new Date(ISODate);
	      },
	      d: function d(dateObj, day) {
	        dateObj.setDate(parseFloat(day));
	      },
	      h: function h(dateObj, hour) {
	        dateObj.setHours(parseFloat(hour));
	      },
	      i: function i(dateObj, minutes) {
	        dateObj.setMinutes(parseFloat(minutes));
	      },
	      j: function j(dateObj, day) {
	        dateObj.setDate(parseFloat(day));
	      },
	      l: do_nothing,
	      m: function m(dateObj, month) {
	        dateObj.setMonth(parseFloat(month) - 1);
	      },
	      n: function n(dateObj, month) {
	        dateObj.setMonth(parseFloat(month) - 1);
	      },
	      s: function s(dateObj, seconds) {
	        dateObj.setSeconds(parseFloat(seconds));
	      },
	      w: do_nothing,
	      y: function y(dateObj, year) {
	        dateObj.setFullYear(2000 + parseFloat(year));
	      }
	    };
	    var tokenRegex = {
	      D: "(\\w+)",
	      F: "(\\w+)",
	      G: "(\\d\\d|\\d)",
	      H: "(\\d\\d|\\d)",
	      J: "(\\d\\d|\\d)\\w+",
	      K: "",
	      M: "(\\w+)",
	      S: "(\\d\\d|\\d)",
	      U: "(.+)",
	      W: "(\\d\\d|\\d)",
	      Y: "(\\d{4})",
	      Z: "(.+)",
	      d: "(\\d\\d|\\d)",
	      h: "(\\d\\d|\\d)",
	      i: "(\\d\\d|\\d)",
	      j: "(\\d\\d|\\d)",
	      l: "(\\w+)",
	      m: "(\\d\\d|\\d)",
	      n: "(\\d\\d|\\d)",
	      s: "(\\d\\d|\\d)",
	      w: "(\\d\\d|\\d)",
	      y: "(\\d{2})"
	    };
	    var formats = {
	      Z: function Z(date) {
	        return date.toISOString();
	      },
	      D: function D(date, locale, options) {
	        return locale.weekdays.shorthand[formats.w(date, locale, options)];
	      },
	      F: function F(date, locale, options) {
	        return monthToStr(formats.n(date, locale, options) - 1, false, locale);
	      },
	      G: function G(date, locale, options) {
	        return pad(formats.h(date, locale, options));
	      },
	      H: function H(date) {
	        return pad(date.getHours());
	      },
	      J: function J(date, locale) {
	        return locale.ordinal !== undefined ? date.getDate() + locale.ordinal(date.getDate()) : date.getDate();
	      },
	      K: function K(date, locale) {
	        return locale.amPM[int(date.getHours() > 11)];
	      },
	      M: function M(date, locale) {
	        return monthToStr(date.getMonth(), true, locale);
	      },
	      S: function S(date) {
	        return pad(date.getSeconds());
	      },
	      U: function U(date) {
	        return date.getTime() / 1000;
	      },
	      W: function W(date, _, options) {
	        return options.getWeek(date);
	      },
	      Y: function Y(date) {
	        return date.getFullYear();
	      },
	      d: function d(date) {
	        return pad(date.getDate());
	      },
	      h: function h(date) {
	        return date.getHours() % 12 ? date.getHours() % 12 : 12;
	      },
	      i: function i(date) {
	        return pad(date.getMinutes());
	      },
	      j: function j(date) {
	        return date.getDate();
	      },
	      l: function l(date, locale) {
	        return locale.weekdays.longhand[date.getDay()];
	      },
	      m: function m(date) {
	        return pad(date.getMonth() + 1);
	      },
	      n: function n(date) {
	        return date.getMonth() + 1;
	      },
	      s: function s(date) {
	        return date.getSeconds();
	      },
	      w: function w(date) {
	        return date.getDay();
	      },
	      y: function y(date) {
	        return String(date.getFullYear()).substring(2);
	      }
	    };
	
	    var english = {
	      weekdays: {
	        shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	        longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
	      },
	      months: {
	        shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
	        longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
	      },
	      daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
	      firstDayOfWeek: 0,
	      ordinal: function ordinal(nth) {
	        var s = nth % 100;
	        if (s > 3 && s < 21) return "th";
	
	        switch (s % 10) {
	          case 1:
	            return "st";
	
	          case 2:
	            return "nd";
	
	          case 3:
	            return "rd";
	
	          default:
	            return "th";
	        }
	      },
	      rangeSeparator: " to ",
	      weekAbbreviation: "Wk",
	      scrollTitle: "Scroll to increment",
	      toggleTitle: "Click to toggle",
	      amPM: ["AM", "PM"],
	      yearAriaLabel: "Year"
	    };
	
	    var createDateFormatter = function createDateFormatter(_ref) {
	      var _ref$config = _ref.config,
	          config = _ref$config === void 0 ? defaults : _ref$config,
	          _ref$l10n = _ref.l10n,
	          l10n = _ref$l10n === void 0 ? english : _ref$l10n;
	      return function (dateObj, frmt, overrideLocale) {
	        var locale = overrideLocale || l10n;
	
	        if (config.formatDate !== undefined) {
	          return config.formatDate(dateObj, frmt, locale);
	        }
	
	        return frmt.split("").map(function (c, i, arr) {
	          return formats[c] && arr[i - 1] !== "\\" ? formats[c](dateObj, locale, config) : c !== "\\" ? c : "";
	        }).join("");
	      };
	    };
	    var createDateParser = function createDateParser(_ref2) {
	      var _ref2$config = _ref2.config,
	          config = _ref2$config === void 0 ? defaults : _ref2$config,
	          _ref2$l10n = _ref2.l10n,
	          l10n = _ref2$l10n === void 0 ? english : _ref2$l10n;
	      return function (date, givenFormat, timeless, customLocale) {
	        if (date !== 0 && !date) return undefined;
	        var locale = customLocale || l10n;
	        var parsedDate;
	        var date_orig = date;
	        if (date instanceof Date) parsedDate = new Date(date.getTime());else if (typeof date !== "string" && date.toFixed !== undefined) parsedDate = new Date(date);else if (typeof date === "string") {
	          var format = givenFormat || (config || defaults).dateFormat;
	          var datestr = String(date).trim();
	
	          if (datestr === "today") {
	            parsedDate = new Date();
	            timeless = true;
	          } else if (/Z$/.test(datestr) || /GMT$/.test(datestr)) parsedDate = new Date(date);else if (config && config.parseDate) parsedDate = config.parseDate(date, format);else {
	            parsedDate = !config || !config.noCalendar ? new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0) : new Date(new Date().setHours(0, 0, 0, 0));
	            var matched,
	                ops = [];
	
	            for (var i = 0, matchIndex = 0, regexStr = ""; i < format.length; i++) {
	              var token = format[i];
	              var isBackSlash = token === "\\";
	              var escaped = format[i - 1] === "\\" || isBackSlash;
	
	              if (tokenRegex[token] && !escaped) {
	                regexStr += tokenRegex[token];
	                var match = new RegExp(regexStr).exec(date);
	
	                if (match && (matched = true)) {
	                  ops[token !== "Y" ? "push" : "unshift"]({
	                    fn: revFormat[token],
	                    val: match[++matchIndex]
	                  });
	                }
	              } else if (!isBackSlash) regexStr += ".";
	
	              ops.forEach(function (_ref3) {
	                var fn = _ref3.fn,
	                    val = _ref3.val;
	                return parsedDate = fn(parsedDate, val, locale) || parsedDate;
	              });
	            }
	
	            parsedDate = matched ? parsedDate : undefined;
	          }
	        }
	
	        if (!(parsedDate instanceof Date && !isNaN(parsedDate.getTime()))) {
	          config.errorHandler(new Error("Invalid date provided: " + date_orig));
	          return undefined;
	        }
	
	        if (timeless === true) parsedDate.setHours(0, 0, 0, 0);
	        return parsedDate;
	      };
	    };
	    function compareDates(date1, date2, timeless) {
	      if (timeless === void 0) {
	        timeless = true;
	      }
	
	      if (timeless !== false) {
	        return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
	      }
	
	      return date1.getTime() - date2.getTime();
	    }
	    var getWeek = function getWeek(givenDate) {
	      var date = new Date(givenDate.getTime());
	      date.setHours(0, 0, 0, 0);
	      date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
	      var week1 = new Date(date.getFullYear(), 0, 4);
	      return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
	    };
	    var isBetween = function isBetween(ts, ts1, ts2) {
	      return ts > Math.min(ts1, ts2) && ts < Math.max(ts1, ts2);
	    };
	    var duration = {
	      DAY: 86400000
	    };
	
	    var HOOKS = ["onChange", "onClose", "onDayCreate", "onDestroy", "onKeyDown", "onMonthChange", "onOpen", "onParseConfig", "onReady", "onValueUpdate", "onYearChange", "onPreCalendarPosition"];
	    var defaults = {
	      _disable: [],
	      _enable: [],
	      allowInput: false,
	      altFormat: "F j, Y",
	      altInput: false,
	      altInputClass: "form-control input",
	      animate: typeof window === "object" && window.navigator.userAgent.indexOf("MSIE") === -1,
	      ariaDateFormat: "F j, Y",
	      clickOpens: true,
	      closeOnSelect: true,
	      conjunction: ", ",
	      dateFormat: "Y-m-d",
	      defaultHour: 12,
	      defaultMinute: 0,
	      defaultSeconds: 0,
	      disable: [],
	      disableMobile: false,
	      enable: [],
	      enableSeconds: false,
	      enableTime: false,
	      errorHandler: function errorHandler(err) {
	        return typeof console !== "undefined" && console.warn(err);
	      },
	      getWeek: getWeek,
	      hourIncrement: 1,
	      ignoredFocusElements: [],
	      inline: false,
	      locale: "default",
	      minuteIncrement: 5,
	      mode: "single",
	      nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	      noCalendar: false,
	      now: new Date(),
	      onChange: [],
	      onClose: [],
	      onDayCreate: [],
	      onDestroy: [],
	      onKeyDown: [],
	      onMonthChange: [],
	      onOpen: [],
	      onParseConfig: [],
	      onReady: [],
	      onValueUpdate: [],
	      onYearChange: [],
	      onPreCalendarPosition: [],
	      plugins: [],
	      position: "auto",
	      positionElement: undefined,
	      prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
	      shorthandCurrentMonth: false,
	      showMonths: 1,
	      static: false,
	      time_24hr: false,
	      weekNumbers: false,
	      wrap: false
	    };
	
	    function toggleClass(elem, className, bool) {
	      if (bool === true) return elem.classList.add(className);
	      elem.classList.remove(className);
	    }
	    function createElement(tag, className, content) {
	      var e = window.document.createElement(tag);
	      className = className || "";
	      content = content || "";
	      e.className = className;
	      if (content !== undefined) e.textContent = content;
	      return e;
	    }
	    function clearNode(node) {
	      while (node.firstChild) {
	        node.removeChild(node.firstChild);
	      }
	    }
	    function findParent(node, condition) {
	      if (condition(node)) return node;else if (node.parentNode) return findParent(node.parentNode, condition);
	      return undefined;
	    }
	    function createNumberInput(inputClassName, opts) {
	      var wrapper = createElement("div", "numInputWrapper"),
	          numInput = createElement("input", "numInput " + inputClassName),
	          arrowUp = createElement("span", "arrowUp"),
	          arrowDown = createElement("span", "arrowDown");
	      numInput.type = "text";
	      numInput.pattern = "\\d*";
	      if (opts !== undefined) for (var key in opts) {
	        numInput.setAttribute(key, opts[key]);
	      }
	      wrapper.appendChild(numInput);
	      wrapper.appendChild(arrowUp);
	      wrapper.appendChild(arrowDown);
	      return wrapper;
	    }
	
	    if (typeof Object.assign !== "function") {
	      Object.assign = function (target) {
	        if (!target) {
	          throw TypeError("Cannot convert undefined or null to object");
	        }
	
	        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        var _loop = function _loop() {
	          var source = args[_i];
	
	          if (source) {
	            Object.keys(source).forEach(function (key) {
	              return target[key] = source[key];
	            });
	          }
	        };
	
	        for (var _i = 0; _i < args.length; _i++) {
	          _loop();
	        }
	
	        return target;
	      };
	    }
	
	    var DEBOUNCED_CHANGE_MS = 300;
	
	    function FlatpickrInstance(element, instanceConfig) {
	      var self = {
	        config: Object.assign({}, flatpickr.defaultConfig),
	        l10n: english
	      };
	      self.parseDate = createDateParser({
	        config: self.config,
	        l10n: self.l10n
	      });
	      self._handlers = [];
	      self._bind = bind;
	      self._setHoursFromDate = setHoursFromDate;
	      self._positionCalendar = positionCalendar;
	      self.changeMonth = changeMonth;
	      self.changeYear = changeYear;
	      self.clear = clear;
	      self.close = close;
	      self._createElement = createElement;
	      self.destroy = destroy;
	      self.isEnabled = isEnabled;
	      self.jumpToDate = jumpToDate;
	      self.open = open;
	      self.redraw = redraw;
	      self.set = set;
	      self.setDate = setDate;
	      self.toggle = toggle;
	
	      function setupHelperFunctions() {
	        self.utils = {
	          getDaysInMonth: function getDaysInMonth(month, yr) {
	            if (month === void 0) {
	              month = self.currentMonth;
	            }
	
	            if (yr === void 0) {
	              yr = self.currentYear;
	            }
	
	            if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
	            return self.l10n.daysInMonth[month];
	          }
	        };
	      }
	
	      function init() {
	        self.element = self.input = element;
	        self.isOpen = false;
	        parseConfig();
	        setupLocale();
	        setupInputs();
	        setupDates();
	        setupHelperFunctions();
	        if (!self.isMobile) build();
	        bindEvents();
	
	        if (self.selectedDates.length || self.config.noCalendar) {
	          if (self.config.enableTime) {
	            setHoursFromDate(self.config.noCalendar ? self.latestSelectedDateObj || self.config.minDate : undefined);
	          }
	
	          updateValue(false);
	        }
	
	        setCalendarWidth();
	        self.showTimeInput = self.selectedDates.length > 0 || self.config.noCalendar;
	        var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	
	        if (!self.isMobile && isSafari) {
	          positionCalendar();
	        }
	
	        triggerEvent("onReady");
	      }
	
	      function bindToInstance(fn) {
	        return fn.bind(self);
	      }
	
	      function setCalendarWidth() {
	        var config = self.config;
	        if (config.weekNumbers === false && config.showMonths === 1) return;else if (config.noCalendar !== true) {
	          window.requestAnimationFrame(function () {
	            self.calendarContainer.style.visibility = "hidden";
	            self.calendarContainer.style.display = "block";
	
	            if (self.daysContainer !== undefined) {
	              var daysWidth = (self.days.offsetWidth + 1) * config.showMonths;
	              self.daysContainer.style.width = daysWidth + "px";
	              self.calendarContainer.style.width = daysWidth + (self.weekWrapper !== undefined ? self.weekWrapper.offsetWidth : 0) + "px";
	              self.calendarContainer.style.removeProperty("visibility");
	              self.calendarContainer.style.removeProperty("display");
	            }
	          });
	        }
	      }
	
	      function updateTime(e) {
	        if (self.selectedDates.length === 0) return;
	
	        if (e !== undefined && e.type !== "blur") {
	          timeWrapper(e);
	        }
	
	        var prevValue = self._input.value;
	        setHoursFromInputs();
	        updateValue();
	
	        if (self._input.value !== prevValue) {
	          self._debouncedChange();
	        }
	      }
	
	      function ampm2military(hour, amPM) {
	        return hour % 12 + 12 * int(amPM === self.l10n.amPM[1]);
	      }
	
	      function military2ampm(hour) {
	        switch (hour % 24) {
	          case 0:
	          case 12:
	            return 12;
	
	          default:
	            return hour % 12;
	        }
	      }
	
	      function setHoursFromInputs() {
	        if (self.hourElement === undefined || self.minuteElement === undefined) return;
	        var hours = (parseInt(self.hourElement.value.slice(-2), 10) || 0) % 24,
	            minutes = (parseInt(self.minuteElement.value, 10) || 0) % 60,
	            seconds = self.secondElement !== undefined ? (parseInt(self.secondElement.value, 10) || 0) % 60 : 0;
	
	        if (self.amPM !== undefined) {
	          hours = ampm2military(hours, self.amPM.textContent);
	        }
	
	        var limitMinHours = self.config.minTime !== undefined || self.config.minDate && self.minDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.minDate, true) === 0;
	        var limitMaxHours = self.config.maxTime !== undefined || self.config.maxDate && self.maxDateHasTime && self.latestSelectedDateObj && compareDates(self.latestSelectedDateObj, self.config.maxDate, true) === 0;
	
	        if (limitMaxHours) {
	          var maxTime = self.config.maxTime !== undefined ? self.config.maxTime : self.config.maxDate;
	          hours = Math.min(hours, maxTime.getHours());
	          if (hours === maxTime.getHours()) minutes = Math.min(minutes, maxTime.getMinutes());
	          if (minutes === maxTime.getMinutes()) seconds = Math.min(seconds, maxTime.getSeconds());
	        }
	
	        if (limitMinHours) {
	          var minTime = self.config.minTime !== undefined ? self.config.minTime : self.config.minDate;
	          hours = Math.max(hours, minTime.getHours());
	          if (hours === minTime.getHours()) minutes = Math.max(minutes, minTime.getMinutes());
	          if (minutes === minTime.getMinutes()) seconds = Math.max(seconds, minTime.getSeconds());
	        }
	
	        setHours(hours, minutes, seconds);
	      }
	
	      function setHoursFromDate(dateObj) {
	        var date = dateObj || self.latestSelectedDateObj;
	        if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
	      }
	
	      function setDefaultHours() {
	        var hours = self.config.defaultHour;
	        var minutes = self.config.defaultMinute;
	        var seconds = self.config.defaultSeconds;
	
	        if (self.config.minDate !== undefined) {
	          var min_hr = self.config.minDate.getHours();
	          var min_minutes = self.config.minDate.getMinutes();
	          hours = Math.max(hours, min_hr);
	          if (hours === min_hr) minutes = Math.max(min_minutes, minutes);
	          if (hours === min_hr && minutes === min_minutes) seconds = self.config.minDate.getSeconds();
	        }
	
	        if (self.config.maxDate !== undefined) {
	          var max_hr = self.config.maxDate.getHours();
	          var max_minutes = self.config.maxDate.getMinutes();
	          hours = Math.min(hours, max_hr);
	          if (hours === max_hr) minutes = Math.min(max_minutes, minutes);
	          if (hours === max_hr && minutes === max_minutes) seconds = self.config.maxDate.getSeconds();
	        }
	
	        setHours(hours, minutes, seconds);
	      }
	
	      function setHours(hours, minutes, seconds) {
	        if (self.latestSelectedDateObj !== undefined) {
	          self.latestSelectedDateObj.setHours(hours % 24, minutes, seconds || 0, 0);
	        }
	
	        if (!self.hourElement || !self.minuteElement || self.isMobile) return;
	        self.hourElement.value = pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * int(hours % 12 === 0) : hours);
	        self.minuteElement.value = pad(minutes);
	        if (self.amPM !== undefined) self.amPM.textContent = self.l10n.amPM[int(hours >= 12)];
	        if (self.secondElement !== undefined) self.secondElement.value = pad(seconds);
	      }
	
	      function onYearInput(event) {
	        var year = parseInt(event.target.value) + (event.delta || 0);
	
	        if (year / 1000 > 1 || event.key === "Enter" && !/[^\d]/.test(year.toString())) {
	          changeYear(year);
	        }
	      }
	
	      function bind(element, event, handler, options) {
	        if (event instanceof Array) return event.forEach(function (ev) {
	          return bind(element, ev, handler, options);
	        });
	        if (element instanceof Array) return element.forEach(function (el) {
	          return bind(el, event, handler, options);
	        });
	        element.addEventListener(event, handler, options);
	
	        self._handlers.push({
	          element: element,
	          event: event,
	          handler: handler,
	          options: options
	        });
	      }
	
	      function onClick(handler) {
	        return function (evt) {
	          evt.which === 1 && handler(evt);
	        };
	      }
	
	      function triggerChange() {
	        triggerEvent("onChange");
	      }
	
	      function bindEvents() {
	        if (self.config.wrap) {
	          ["open", "close", "toggle", "clear"].forEach(function (evt) {
	            Array.prototype.forEach.call(self.element.querySelectorAll("[data-" + evt + "]"), function (el) {
	              return bind(el, "click", self[evt]);
	            });
	          });
	        }
	
	        if (self.isMobile) {
	          setupMobile();
	          return;
	        }
	
	        var debouncedResize = debounce(onResize, 50);
	        self._debouncedChange = debounce(triggerChange, DEBOUNCED_CHANGE_MS);
	        if (self.daysContainer && !/iPhone|iPad|iPod/i.test(navigator.userAgent)) bind(self.daysContainer, "mouseover", function (e) {
	          if (self.config.mode === "range") onMouseOver(e.target);
	        });
	        bind(window.document.body, "keydown", onKeyDown);
	        if (!self.config.static) bind(self._input, "keydown", onKeyDown);
	        if (!self.config.inline && !self.config.static) bind(window, "resize", debouncedResize);
	        if (window.ontouchstart !== undefined) bind(window.document, "click", documentClick);else bind(window.document, "mousedown", onClick(documentClick));
	        bind(window.document, "focus", documentClick, {
	          capture: true
	        });
	
	        if (self.config.clickOpens === true) {
	          bind(self._input, "focus", self.open);
	          bind(self._input, "mousedown", onClick(self.open));
	        }
	
	        if (self.daysContainer !== undefined) {
	          bind(self.monthNav, "mousedown", onClick(onMonthNavClick));
	          bind(self.monthNav, ["keyup", "increment"], onYearInput);
	          bind(self.daysContainer, "mousedown", onClick(selectDate));
	        }
	
	        if (self.timeContainer !== undefined && self.minuteElement !== undefined && self.hourElement !== undefined) {
	          var selText = function selText(e) {
	            return e.target.select();
	          };
	
	          bind(self.timeContainer, ["increment"], updateTime);
	          bind(self.timeContainer, "blur", updateTime, {
	            capture: true
	          });
	          bind(self.timeContainer, "mousedown", onClick(timeIncrement));
	          bind([self.hourElement, self.minuteElement], ["focus", "click"], selText);
	          if (self.secondElement !== undefined) bind(self.secondElement, "focus", function () {
	            return self.secondElement && self.secondElement.select();
	          });
	
	          if (self.amPM !== undefined) {
	            bind(self.amPM, "mousedown", onClick(function (e) {
	              updateTime(e);
	              triggerChange();
	            }));
	          }
	        }
	      }
	
	      function jumpToDate(jumpDate) {
	        var jumpTo = jumpDate !== undefined ? self.parseDate(jumpDate) : self.latestSelectedDateObj || (self.config.minDate && self.config.minDate > self.now ? self.config.minDate : self.config.maxDate && self.config.maxDate < self.now ? self.config.maxDate : self.now);
	
	        try {
	          if (jumpTo !== undefined) {
	            self.currentYear = jumpTo.getFullYear();
	            self.currentMonth = jumpTo.getMonth();
	          }
	        } catch (e) {
	          e.message = "Invalid date supplied: " + jumpTo;
	          self.config.errorHandler(e);
	        }
	
	        self.redraw();
	      }
	
	      function timeIncrement(e) {
	        if (~e.target.className.indexOf("arrow")) incrementNumInput(e, e.target.classList.contains("arrowUp") ? 1 : -1);
	      }
	
	      function incrementNumInput(e, delta, inputElem) {
	        var target = e && e.target;
	        var input = inputElem || target && target.parentNode && target.parentNode.firstChild;
	        var event = createEvent("increment");
	        event.delta = delta;
	        input && input.dispatchEvent(event);
	      }
	
	      function build() {
	        var fragment = window.document.createDocumentFragment();
	        self.calendarContainer = createElement("div", "flatpickr-calendar");
	        self.calendarContainer.tabIndex = -1;
	
	        if (!self.config.noCalendar) {
	          fragment.appendChild(buildMonthNav());
	          self.innerContainer = createElement("div", "flatpickr-innerContainer");
	
	          if (self.config.weekNumbers) {
	            var _buildWeeks = buildWeeks(),
	                weekWrapper = _buildWeeks.weekWrapper,
	                weekNumbers = _buildWeeks.weekNumbers;
	
	            self.innerContainer.appendChild(weekWrapper);
	            self.weekNumbers = weekNumbers;
	            self.weekWrapper = weekWrapper;
	          }
	
	          self.rContainer = createElement("div", "flatpickr-rContainer");
	          self.rContainer.appendChild(buildWeekdays());
	
	          if (!self.daysContainer) {
	            self.daysContainer = createElement("div", "flatpickr-days");
	            self.daysContainer.tabIndex = -1;
	          }
	
	          buildDays();
	          self.rContainer.appendChild(self.daysContainer);
	          self.innerContainer.appendChild(self.rContainer);
	          fragment.appendChild(self.innerContainer);
	        }
	
	        if (self.config.enableTime) {
	          fragment.appendChild(buildTime());
	        }
	
	        toggleClass(self.calendarContainer, "rangeMode", self.config.mode === "range");
	        toggleClass(self.calendarContainer, "animate", self.config.animate === true);
	        toggleClass(self.calendarContainer, "multiMonth", self.config.showMonths > 1);
	        self.calendarContainer.appendChild(fragment);
	        var customAppend = self.config.appendTo !== undefined && self.config.appendTo.nodeType !== undefined;
	
	        if (self.config.inline || self.config.static) {
	          self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
	
	          if (self.config.inline) {
	            if (!customAppend && self.element.parentNode) self.element.parentNode.insertBefore(self.calendarContainer, self._input.nextSibling);else if (self.config.appendTo !== undefined) self.config.appendTo.appendChild(self.calendarContainer);
	          }
	
	          if (self.config.static) {
	            var wrapper = createElement("div", "flatpickr-wrapper");
	            if (self.element.parentNode) self.element.parentNode.insertBefore(wrapper, self.element);
	            wrapper.appendChild(self.element);
	            if (self.altInput) wrapper.appendChild(self.altInput);
	            wrapper.appendChild(self.calendarContainer);
	          }
	        }
	
	        if (!self.config.static && !self.config.inline) (self.config.appendTo !== undefined ? self.config.appendTo : window.document.body).appendChild(self.calendarContainer);
	      }
	
	      function createDay(className, date, dayNumber, i) {
	        var dateIsEnabled = isEnabled(date, true),
	            dayElement = createElement("span", "flatpickr-day " + className, date.getDate().toString());
	        dayElement.dateObj = date;
	        dayElement.$i = i;
	        dayElement.setAttribute("aria-label", self.formatDate(date, self.config.ariaDateFormat));
	
	        if (className.indexOf("hidden") === -1 && compareDates(date, self.now) === 0) {
	          self.todayDateElem = dayElement;
	          dayElement.classList.add("today");
	          dayElement.setAttribute("aria-current", "date");
	        }
	
	        if (dateIsEnabled) {
	          dayElement.tabIndex = -1;
	
	          if (isDateSelected(date)) {
	            dayElement.classList.add("selected");
	            self.selectedDateElem = dayElement;
	
	            if (self.config.mode === "range") {
	              toggleClass(dayElement, "startRange", self.selectedDates[0] && compareDates(date, self.selectedDates[0], true) === 0);
	              toggleClass(dayElement, "endRange", self.selectedDates[1] && compareDates(date, self.selectedDates[1], true) === 0);
	              if (className === "nextMonthDay") dayElement.classList.add("inRange");
	            }
	          }
	        } else {
	          dayElement.classList.add("disabled");
	        }
	
	        if (self.config.mode === "range") {
	          if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
	        }
	
	        if (self.weekNumbers && self.config.showMonths === 1 && className !== "prevMonthDay" && dayNumber % 7 === 1) {
	          self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='flatpickr-day'>" + self.config.getWeek(date) + "</span>");
	        }
	
	        triggerEvent("onDayCreate", dayElement);
	        return dayElement;
	      }
	
	      function focusOnDayElem(targetNode) {
	        targetNode.focus();
	        if (self.config.mode === "range") onMouseOver(targetNode);
	      }
	
	      function getFirstAvailableDay(delta) {
	        var startMonth = delta > 0 ? 0 : self.config.showMonths - 1;
	        var endMonth = delta > 0 ? self.config.showMonths : -1;
	
	        for (var m = startMonth; m != endMonth; m += delta) {
	          var month = self.daysContainer.children[m];
	          var startIndex = delta > 0 ? 0 : month.children.length - 1;
	          var endIndex = delta > 0 ? month.children.length : -1;
	
	          for (var i = startIndex; i != endIndex; i += delta) {
	            var c = month.children[i];
	            if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj)) return c;
	          }
	        }
	
	        return undefined;
	      }
	
	      function getNextAvailableDay(current, delta) {
	        var givenMonth = current.className.indexOf("Month") === -1 ? current.dateObj.getMonth() : self.currentMonth;
	        var endMonth = delta > 0 ? self.config.showMonths : -1;
	        var loopDelta = delta > 0 ? 1 : -1;
	
	        for (var m = givenMonth - self.currentMonth; m != endMonth; m += loopDelta) {
	          var month = self.daysContainer.children[m];
	          var startIndex = givenMonth - self.currentMonth === m ? current.$i + delta : delta < 0 ? month.children.length - 1 : 0;
	          var numMonthDays = month.children.length;
	
	          for (var i = startIndex; i >= 0 && i < numMonthDays && i != (delta > 0 ? numMonthDays : -1); i += loopDelta) {
	            var c = month.children[i];
	            if (c.className.indexOf("hidden") === -1 && isEnabled(c.dateObj) && Math.abs(current.$i - i) >= Math.abs(delta)) return focusOnDayElem(c);
	          }
	        }
	
	        self.changeMonth(loopDelta);
	        focusOnDay(getFirstAvailableDay(loopDelta), 0);
	        return undefined;
	      }
	
	      function focusOnDay(current, offset) {
	        var dayFocused = isInView(document.activeElement || document.body);
	        var startElem = current !== undefined ? current : dayFocused ? document.activeElement : self.selectedDateElem !== undefined && isInView(self.selectedDateElem) ? self.selectedDateElem : self.todayDateElem !== undefined && isInView(self.todayDateElem) ? self.todayDateElem : getFirstAvailableDay(offset > 0 ? 1 : -1);
	        if (startElem === undefined) return self._input.focus();
	        if (!dayFocused) return focusOnDayElem(startElem);
	        getNextAvailableDay(startElem, offset);
	      }
	
	      function buildMonthDays(year, month) {
	        var firstOfMonth = (new Date(year, month, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	        var prevMonthDays = self.utils.getDaysInMonth((month - 1 + 12) % 12);
	        var daysInMonth = self.utils.getDaysInMonth(month),
	            days = window.document.createDocumentFragment(),
	            isMultiMonth = self.config.showMonths > 1,
	            prevMonthDayClass = isMultiMonth ? "prevMonthDay hidden" : "prevMonthDay",
	            nextMonthDayClass = isMultiMonth ? "nextMonthDay hidden" : "nextMonthDay";
	        var dayNumber = prevMonthDays + 1 - firstOfMonth,
	            dayIndex = 0;
	
	        for (; dayNumber <= prevMonthDays; dayNumber++, dayIndex++) {
	          days.appendChild(createDay(prevMonthDayClass, new Date(year, month - 1, dayNumber), dayNumber, dayIndex));
	        }
	
	        for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++, dayIndex++) {
	          days.appendChild(createDay("", new Date(year, month, dayNumber), dayNumber, dayIndex));
	        }
	
	        for (var dayNum = daysInMonth + 1; dayNum <= 42 - firstOfMonth && (self.config.showMonths === 1 || dayIndex % 7 !== 0); dayNum++, dayIndex++) {
	          days.appendChild(createDay(nextMonthDayClass, new Date(year, month + 1, dayNum % daysInMonth), dayNum, dayIndex));
	        }
	
	        var dayContainer = createElement("div", "dayContainer");
	        dayContainer.appendChild(days);
	        return dayContainer;
	      }
	
	      function buildDays() {
	        if (self.daysContainer === undefined) {
	          return;
	        }
	
	        clearNode(self.daysContainer);
	        if (self.weekNumbers) clearNode(self.weekNumbers);
	        var frag = document.createDocumentFragment();
	
	        for (var i = 0; i < self.config.showMonths; i++) {
	          var d = new Date(self.currentYear, self.currentMonth, 1);
	          d.setMonth(self.currentMonth + i);
	          frag.appendChild(buildMonthDays(d.getFullYear(), d.getMonth()));
	        }
	
	        self.daysContainer.appendChild(frag);
	        self.days = self.daysContainer.firstChild;
	
	        if (self.config.mode === "range" && self.selectedDates.length === 1) {
	          onMouseOver();
	        }
	      }
	
	      function buildMonth() {
	        var container = createElement("div", "flatpickr-month");
	        var monthNavFragment = window.document.createDocumentFragment();
	        var monthElement = createElement("span", "cur-month");
	        var yearInput = createNumberInput("cur-year", {
	          tabindex: "-1"
	        });
	        var yearElement = yearInput.getElementsByTagName("input")[0];
	        yearElement.setAttribute("aria-label", self.l10n.yearAriaLabel);
	        if (self.config.minDate) yearElement.setAttribute("data-min", self.config.minDate.getFullYear().toString());
	
	        if (self.config.maxDate) {
	          yearElement.setAttribute("data-max", self.config.maxDate.getFullYear().toString());
	          yearElement.disabled = !!self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
	        }
	
	        var currentMonth = createElement("div", "flatpickr-current-month");
	        currentMonth.appendChild(monthElement);
	        currentMonth.appendChild(yearInput);
	        monthNavFragment.appendChild(currentMonth);
	        container.appendChild(monthNavFragment);
	        return {
	          container: container,
	          yearElement: yearElement,
	          monthElement: monthElement
	        };
	      }
	
	      function buildMonths() {
	        clearNode(self.monthNav);
	        self.monthNav.appendChild(self.prevMonthNav);
	
	        for (var m = self.config.showMonths; m--;) {
	          var month = buildMonth();
	          self.yearElements.push(month.yearElement);
	          self.monthElements.push(month.monthElement);
	          self.monthNav.appendChild(month.container);
	        }
	
	        self.monthNav.appendChild(self.nextMonthNav);
	      }
	
	      function buildMonthNav() {
	        self.monthNav = createElement("div", "flatpickr-months");
	        self.yearElements = [];
	        self.monthElements = [];
	        self.prevMonthNav = createElement("span", "flatpickr-prev-month");
	        self.prevMonthNav.innerHTML = self.config.prevArrow;
	        self.nextMonthNav = createElement("span", "flatpickr-next-month");
	        self.nextMonthNav.innerHTML = self.config.nextArrow;
	        buildMonths();
	        Object.defineProperty(self, "_hidePrevMonthArrow", {
	          get: function get() {
	            return self.__hidePrevMonthArrow;
	          },
	          set: function set(bool) {
	            if (self.__hidePrevMonthArrow !== bool) {
	              toggleClass(self.prevMonthNav, "disabled", bool);
	              self.__hidePrevMonthArrow = bool;
	            }
	          }
	        });
	        Object.defineProperty(self, "_hideNextMonthArrow", {
	          get: function get() {
	            return self.__hideNextMonthArrow;
	          },
	          set: function set(bool) {
	            if (self.__hideNextMonthArrow !== bool) {
	              toggleClass(self.nextMonthNav, "disabled", bool);
	              self.__hideNextMonthArrow = bool;
	            }
	          }
	        });
	        self.currentYearElement = self.yearElements[0];
	        updateNavigationCurrentMonth();
	        return self.monthNav;
	      }
	
	      function buildTime() {
	        self.calendarContainer.classList.add("hasTime");
	        if (self.config.noCalendar) self.calendarContainer.classList.add("noCalendar");
	        self.timeContainer = createElement("div", "flatpickr-time");
	        self.timeContainer.tabIndex = -1;
	        var separator = createElement("span", "flatpickr-time-separator", ":");
	        var hourInput = createNumberInput("flatpickr-hour");
	        self.hourElement = hourInput.getElementsByTagName("input")[0];
	        var minuteInput = createNumberInput("flatpickr-minute");
	        self.minuteElement = minuteInput.getElementsByTagName("input")[0];
	        self.hourElement.tabIndex = self.minuteElement.tabIndex = -1;
	        self.hourElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getHours() : self.config.time_24hr ? self.config.defaultHour : military2ampm(self.config.defaultHour));
	        self.minuteElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getMinutes() : self.config.defaultMinute);
	        self.hourElement.setAttribute("data-step", self.config.hourIncrement.toString());
	        self.minuteElement.setAttribute("data-step", self.config.minuteIncrement.toString());
	        self.hourElement.setAttribute("data-min", self.config.time_24hr ? "0" : "1");
	        self.hourElement.setAttribute("data-max", self.config.time_24hr ? "23" : "12");
	        self.minuteElement.setAttribute("data-min", "0");
	        self.minuteElement.setAttribute("data-max", "59");
	        self.timeContainer.appendChild(hourInput);
	        self.timeContainer.appendChild(separator);
	        self.timeContainer.appendChild(minuteInput);
	        if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
	
	        if (self.config.enableSeconds) {
	          self.timeContainer.classList.add("hasSeconds");
	          var secondInput = createNumberInput("flatpickr-second");
	          self.secondElement = secondInput.getElementsByTagName("input")[0];
	          self.secondElement.value = pad(self.latestSelectedDateObj ? self.latestSelectedDateObj.getSeconds() : self.config.defaultSeconds);
	          self.secondElement.setAttribute("data-step", self.minuteElement.getAttribute("data-step"));
	          self.secondElement.setAttribute("data-min", self.minuteElement.getAttribute("data-min"));
	          self.secondElement.setAttribute("data-max", self.minuteElement.getAttribute("data-max"));
	          self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
	          self.timeContainer.appendChild(secondInput);
	        }
	
	        if (!self.config.time_24hr) {
	          self.amPM = createElement("span", "flatpickr-am-pm", self.l10n.amPM[int((self.latestSelectedDateObj ? self.hourElement.value : self.config.defaultHour) > 11)]);
	          self.amPM.title = self.l10n.toggleTitle;
	          self.amPM.tabIndex = -1;
	          self.timeContainer.appendChild(self.amPM);
	        }
	
	        return self.timeContainer;
	      }
	
	      function buildWeekdays() {
	        if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");else clearNode(self.weekdayContainer);
	
	        for (var i = self.config.showMonths; i--;) {
	          var container = createElement("div", "flatpickr-weekdaycontainer");
	          self.weekdayContainer.appendChild(container);
	        }
	
	        updateWeekdays();
	        return self.weekdayContainer;
	      }
	
	      function updateWeekdays() {
	        var firstDayOfWeek = self.l10n.firstDayOfWeek;
	        var weekdays = self.l10n.weekdays.shorthand.concat();
	
	        if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
	          weekdays = weekdays.splice(firstDayOfWeek, weekdays.length).concat(weekdays.splice(0, firstDayOfWeek));
	        }
	
	        for (var i = self.config.showMonths; i--;) {
	          self.weekdayContainer.children[i].innerHTML = "\n      <span class=flatpickr-weekday>\n        " + weekdays.join("</span><span class=flatpickr-weekday>") + "\n      </span>\n      ";
	        }
	      }
	
	      function buildWeeks() {
	        self.calendarContainer.classList.add("hasWeeks");
	        var weekWrapper = createElement("div", "flatpickr-weekwrapper");
	        weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
	        var weekNumbers = createElement("div", "flatpickr-weeks");
	        weekWrapper.appendChild(weekNumbers);
	        return {
	          weekWrapper: weekWrapper,
	          weekNumbers: weekNumbers
	        };
	      }
	
	      function changeMonth(value, is_offset) {
	        if (is_offset === void 0) {
	          is_offset = true;
	        }
	
	        var delta = is_offset ? value : value - self.currentMonth;
	        if (delta < 0 && self._hidePrevMonthArrow === true || delta > 0 && self._hideNextMonthArrow === true) return;
	        self.currentMonth += delta;
	
	        if (self.currentMonth < 0 || self.currentMonth > 11) {
	          self.currentYear += self.currentMonth > 11 ? 1 : -1;
	          self.currentMonth = (self.currentMonth + 12) % 12;
	          triggerEvent("onYearChange");
	        }
	
	        buildDays();
	        triggerEvent("onMonthChange");
	        updateNavigationCurrentMonth();
	      }
	
	      function clear(triggerChangeEvent) {
	        if (triggerChangeEvent === void 0) {
	          triggerChangeEvent = true;
	        }
	
	        self.input.value = "";
	        if (self.altInput !== undefined) self.altInput.value = "";
	        if (self.mobileInput !== undefined) self.mobileInput.value = "";
	        self.selectedDates = [];
	        self.latestSelectedDateObj = undefined;
	        self.showTimeInput = false;
	
	        if (self.config.enableTime === true) {
	          setDefaultHours();
	        }
	
	        self.redraw();
	        if (triggerChangeEvent) triggerEvent("onChange");
	      }
	
	      function close() {
	        self.isOpen = false;
	
	        if (!self.isMobile) {
	          self.calendarContainer.classList.remove("open");
	
	          self._input.classList.remove("active");
	        }
	
	        triggerEvent("onClose");
	      }
	
	      function destroy() {
	        if (self.config !== undefined) triggerEvent("onDestroy");
	
	        for (var i = self._handlers.length; i--;) {
	          var h = self._handlers[i];
	          h.element.removeEventListener(h.event, h.handler, h.options);
	        }
	
	        self._handlers = [];
	
	        if (self.mobileInput) {
	          if (self.mobileInput.parentNode) self.mobileInput.parentNode.removeChild(self.mobileInput);
	          self.mobileInput = undefined;
	        } else if (self.calendarContainer && self.calendarContainer.parentNode) {
	          if (self.config.static && self.calendarContainer.parentNode) {
	            var wrapper = self.calendarContainer.parentNode;
	            wrapper.lastChild && wrapper.removeChild(wrapper.lastChild);
	
	            if (wrapper.parentNode) {
	              while (wrapper.firstChild) {
	                wrapper.parentNode.insertBefore(wrapper.firstChild, wrapper);
	              }
	
	              wrapper.parentNode.removeChild(wrapper);
	            }
	          } else self.calendarContainer.parentNode.removeChild(self.calendarContainer);
	        }
	
	        if (self.altInput) {
	          self.input.type = "text";
	          if (self.altInput.parentNode) self.altInput.parentNode.removeChild(self.altInput);
	          delete self.altInput;
	        }
	
	        if (self.input) {
	          self.input.type = self.input._type;
	          self.input.classList.remove("flatpickr-input");
	          self.input.removeAttribute("readonly");
	          self.input.value = "";
	        }
	
	        ["_showTimeInput", "latestSelectedDateObj", "_hideNextMonthArrow", "_hidePrevMonthArrow", "__hideNextMonthArrow", "__hidePrevMonthArrow", "isMobile", "isOpen", "selectedDateElem", "minDateHasTime", "maxDateHasTime", "days", "daysContainer", "_input", "_positionElement", "innerContainer", "rContainer", "monthNav", "todayDateElem", "calendarContainer", "weekdayContainer", "prevMonthNav", "nextMonthNav", "currentMonthElement", "currentYearElement", "navigationCurrentMonth", "selectedDateElem", "config"].forEach(function (k) {
	          try {
	            delete self[k];
	          } catch (_) {}
	        });
	      }
	
	      function isCalendarElem(elem) {
	        if (self.config.appendTo && self.config.appendTo.contains(elem)) return true;
	        return self.calendarContainer.contains(elem);
	      }
	
	      function documentClick(e) {
	        if (self.isOpen && !self.config.inline) {
	          var isCalendarElement = isCalendarElem(e.target);
	          var isInput = e.target === self.input || e.target === self.altInput || self.element.contains(e.target) || e.path && e.path.indexOf && (~e.path.indexOf(self.input) || ~e.path.indexOf(self.altInput));
	          var lostFocus = e.type === "blur" ? isInput && e.relatedTarget && !isCalendarElem(e.relatedTarget) : !isInput && !isCalendarElement;
	          var isIgnored = !self.config.ignoredFocusElements.some(function (elem) {
	            return elem.contains(e.target);
	          });
	
	          if (lostFocus && isIgnored) {
	            self.close();
	
	            if (self.config.mode === "range" && self.selectedDates.length === 1) {
	              self.clear(false);
	              self.redraw();
	            }
	          }
	        }
	      }
	
	      function changeYear(newYear) {
	        if (!newYear || self.config.minDate && newYear < self.config.minDate.getFullYear() || self.config.maxDate && newYear > self.config.maxDate.getFullYear()) return;
	        var newYearNum = newYear,
	            isNewYear = self.currentYear !== newYearNum;
	        self.currentYear = newYearNum || self.currentYear;
	
	        if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
	          self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
	        } else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
	          self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
	        }
	
	        if (isNewYear) {
	          self.redraw();
	          triggerEvent("onYearChange");
	        }
	      }
	
	      function isEnabled(date, timeless) {
	        if (timeless === void 0) {
	          timeless = true;
	        }
	
	        var dateToCheck = self.parseDate(date, undefined, timeless);
	        if (self.config.minDate && dateToCheck && compareDates(dateToCheck, self.config.minDate, timeless !== undefined ? timeless : !self.minDateHasTime) < 0 || self.config.maxDate && dateToCheck && compareDates(dateToCheck, self.config.maxDate, timeless !== undefined ? timeless : !self.maxDateHasTime) > 0) return false;
	        if (self.config.enable.length === 0 && self.config.disable.length === 0) return true;
	        if (dateToCheck === undefined) return false;
	        var bool = self.config.enable.length > 0,
	            array = bool ? self.config.enable : self.config.disable;
	
	        for (var i = 0, d; i < array.length; i++) {
	          d = array[i];
	          if (typeof d === "function" && d(dateToCheck)) return bool;else if (d instanceof Date && dateToCheck !== undefined && d.getTime() === dateToCheck.getTime()) return bool;else if (typeof d === "string" && dateToCheck !== undefined) {
	            var parsed = self.parseDate(d, undefined, true);
	            return parsed && parsed.getTime() === dateToCheck.getTime() ? bool : !bool;
	          } else if (typeof d === "object" && dateToCheck !== undefined && d.from && d.to && dateToCheck.getTime() >= d.from.getTime() && dateToCheck.getTime() <= d.to.getTime()) return bool;
	        }
	
	        return !bool;
	      }
	
	      function isInView(elem) {
	        if (self.daysContainer !== undefined) return elem.className.indexOf("hidden") === -1 && self.daysContainer.contains(elem);
	        return false;
	      }
	
	      function onKeyDown(e) {
	        var isInput = e.target === self._input;
	        var allowInput = self.config.allowInput;
	        var allowKeydown = self.isOpen && (!allowInput || !isInput);
	        var allowInlineKeydown = self.config.inline && isInput && !allowInput;
	
	        if (e.keyCode === 13 && isInput) {
	          if (allowInput) {
	            self.setDate(self._input.value, true, e.target === self.altInput ? self.config.altFormat : self.config.dateFormat);
	            return e.target.blur();
	          } else self.open();
	        } else if (isCalendarElem(e.target) || allowKeydown || allowInlineKeydown) {
	          var isTimeObj = !!self.timeContainer && self.timeContainer.contains(e.target);
	
	          switch (e.keyCode) {
	            case 13:
	              if (isTimeObj) updateTime();else selectDate(e);
	              break;
	
	            case 27:
	              e.preventDefault();
	              focusAndClose();
	              break;
	
	            case 8:
	            case 46:
	              if (isInput && !self.config.allowInput) {
	                e.preventDefault();
	                self.clear();
	              }
	
	              break;
	
	            case 37:
	            case 39:
	              if (!isTimeObj) {
	                e.preventDefault();
	
	                if (self.daysContainer !== undefined && (allowInput === false || isInView(document.activeElement))) {
	                  var _delta = e.keyCode === 39 ? 1 : -1;
	
	                  if (!e.ctrlKey) focusOnDay(undefined, _delta);else {
	                    changeMonth(_delta);
	                    focusOnDay(getFirstAvailableDay(1), 0);
	                  }
	                }
	              } else if (self.hourElement) self.hourElement.focus();
	
	              break;
	
	            case 38:
	            case 40:
	              e.preventDefault();
	              var delta = e.keyCode === 40 ? 1 : -1;
	
	              if (self.daysContainer && e.target.$i !== undefined) {
	                if (e.ctrlKey) {
	                  changeYear(self.currentYear - delta);
	                  focusOnDay(getFirstAvailableDay(1), 0);
	                } else if (!isTimeObj) focusOnDay(undefined, delta * 7);
	              } else if (self.config.enableTime) {
	                if (!isTimeObj && self.hourElement) self.hourElement.focus();
	                updateTime(e);
	
	                self._debouncedChange();
	              }
	
	              break;
	
	            case 9:
	              if (!isTimeObj) {
	                self.element.focus();
	                break;
	              }
	
	              var elems = [self.hourElement, self.minuteElement, self.secondElement, self.amPM].filter(function (x) {
	                return x;
	              });
	              var i = elems.indexOf(e.target);
	
	              if (i !== -1) {
	                var target = elems[i + (e.shiftKey ? -1 : 1)];
	
	                if (target !== undefined) {
	                  e.preventDefault();
	                  target.focus();
	                } else {
	                  self.element.focus();
	                }
	              }
	
	              break;
	
	            default:
	              break;
	          }
	        }
	
	        if (self.amPM !== undefined && e.target === self.amPM) {
	          switch (e.key) {
	            case self.l10n.amPM[0].charAt(0):
	            case self.l10n.amPM[0].charAt(0).toLowerCase():
	              self.amPM.textContent = self.l10n.amPM[0];
	              setHoursFromInputs();
	              updateValue();
	              break;
	
	            case self.l10n.amPM[1].charAt(0):
	            case self.l10n.amPM[1].charAt(0).toLowerCase():
	              self.amPM.textContent = self.l10n.amPM[1];
	              setHoursFromInputs();
	              updateValue();
	              break;
	          }
	        }
	
	        triggerEvent("onKeyDown", e);
	      }
	
	      function onMouseOver(elem) {
	        if (self.selectedDates.length !== 1 || elem && (!elem.classList.contains("flatpickr-day") || elem.classList.contains("disabled"))) return;
	        var hoverDate = elem ? elem.dateObj.getTime() : self.days.firstElementChild.dateObj.getTime(),
	            initialDate = self.parseDate(self.selectedDates[0], undefined, true).getTime(),
	            rangeStartDate = Math.min(hoverDate, self.selectedDates[0].getTime()),
	            rangeEndDate = Math.max(hoverDate, self.selectedDates[0].getTime()),
	            lastDate = self.daysContainer.lastChild.lastChild.dateObj.getTime();
	        var containsDisabled = false;
	        var minRange = 0,
	            maxRange = 0;
	
	        for (var t = rangeStartDate; t < lastDate; t += duration.DAY) {
	          if (!isEnabled(new Date(t), true)) {
	            containsDisabled = containsDisabled || t > rangeStartDate && t < rangeEndDate;
	            if (t < initialDate && (!minRange || t > minRange)) minRange = t;else if (t > initialDate && (!maxRange || t < maxRange)) maxRange = t;
	          }
	        }
	
	        for (var m = 0; m < self.config.showMonths; m++) {
	          var month = self.daysContainer.children[m];
	          var prevMonth = self.daysContainer.children[m - 1];
	
	          var _loop = function _loop(i, l) {
	            var dayElem = month.children[i],
	                date = dayElem.dateObj;
	            var timestamp = date.getTime();
	            var outOfRange = minRange > 0 && timestamp < minRange || maxRange > 0 && timestamp > maxRange;
	
	            if (outOfRange) {
	              dayElem.classList.add("notAllowed");
	              ["inRange", "startRange", "endRange"].forEach(function (c) {
	                dayElem.classList.remove(c);
	              });
	              return "continue";
	            } else if (containsDisabled && !outOfRange) return "continue";
	
	            ["startRange", "inRange", "endRange", "notAllowed"].forEach(function (c) {
	              dayElem.classList.remove(c);
	            });
	
	            if (elem !== undefined) {
	              elem.classList.add(hoverDate < self.selectedDates[0].getTime() ? "startRange" : "endRange");
	
	              if (month.contains(elem) || !(m > 0 && prevMonth && prevMonth.lastChild.dateObj.getTime() >= timestamp)) {
	                if (initialDate < hoverDate && timestamp === initialDate) dayElem.classList.add("startRange");else if (initialDate > hoverDate && timestamp === initialDate) dayElem.classList.add("endRange");
	                if (timestamp >= minRange && (maxRange === 0 || timestamp <= maxRange) && isBetween(timestamp, initialDate, hoverDate)) dayElem.classList.add("inRange");
	              }
	            }
	          };
	
	          for (var i = 0, l = month.children.length; i < l; i++) {
	            var _ret = _loop(i, l);
	
	            if (_ret === "continue") continue;
	          }
	        }
	      }
	
	      function onResize() {
	        if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
	      }
	
	      function open(e, positionElement) {
	        if (positionElement === void 0) {
	          positionElement = self._positionElement;
	        }
	
	        if (self.isMobile === true) {
	          if (e) {
	            e.preventDefault();
	            e.target && e.target.blur();
	          }
	
	          if (self.mobileInput !== undefined) {
	            self.mobileInput.focus();
	            self.mobileInput.click();
	          }
	
	          triggerEvent("onOpen");
	          return;
	        }
	
	        if (self._input.disabled || self.config.inline) return;
	        var wasOpen = self.isOpen;
	        self.isOpen = true;
	
	        if (!wasOpen) {
	          self.calendarContainer.classList.add("open");
	
	          self._input.classList.add("active");
	
	          triggerEvent("onOpen");
	          positionCalendar(positionElement);
	        }
	
	        if (self.config.enableTime === true && self.config.noCalendar === true) {
	          if (self.selectedDates.length === 0) {
	            self.setDate(self.config.minDate !== undefined ? new Date(self.config.minDate.getTime()) : new Date(), false);
	            setDefaultHours();
	            updateValue();
	          }
	
	          if (self.config.allowInput === false && (e === undefined || !self.timeContainer.contains(e.relatedTarget))) {
	            setTimeout(function () {
	              return self.hourElement.select();
	            }, 50);
	          }
	        }
	      }
	
	      function minMaxDateSetter(type) {
	        return function (date) {
	          var dateObj = self.config["_" + type + "Date"] = self.parseDate(date, self.config.dateFormat);
	          var inverseDateObj = self.config["_" + (type === "min" ? "max" : "min") + "Date"];
	
	          if (dateObj !== undefined) {
	            self[type === "min" ? "minDateHasTime" : "maxDateHasTime"] = dateObj.getHours() > 0 || dateObj.getMinutes() > 0 || dateObj.getSeconds() > 0;
	          }
	
	          if (self.selectedDates) {
	            self.selectedDates = self.selectedDates.filter(function (d) {
	              return isEnabled(d);
	            });
	            if (!self.selectedDates.length && type === "min") setHoursFromDate(dateObj);
	            updateValue();
	          }
	
	          if (self.daysContainer) {
	            redraw();
	            if (dateObj !== undefined) self.currentYearElement[type] = dateObj.getFullYear().toString();else self.currentYearElement.removeAttribute(type);
	            self.currentYearElement.disabled = !!inverseDateObj && dateObj !== undefined && inverseDateObj.getFullYear() === dateObj.getFullYear();
	          }
	        };
	      }
	
	      function parseConfig() {
	        var boolOpts = ["wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
	        var userConfig = Object.assign({}, instanceConfig, JSON.parse(JSON.stringify(element.dataset || {})));
	        var formats$$1 = {};
	        self.config.parseDate = userConfig.parseDate;
	        self.config.formatDate = userConfig.formatDate;
	        Object.defineProperty(self.config, "enable", {
	          get: function get() {
	            return self.config._enable;
	          },
	          set: function set(dates) {
	            self.config._enable = parseDateRules(dates);
	          }
	        });
	        Object.defineProperty(self.config, "disable", {
	          get: function get() {
	            return self.config._disable;
	          },
	          set: function set(dates) {
	            self.config._disable = parseDateRules(dates);
	          }
	        });
	        var timeMode = userConfig.mode === "time";
	
	        if (!userConfig.dateFormat && (userConfig.enableTime || timeMode)) {
	          formats$$1.dateFormat = userConfig.noCalendar || timeMode ? "H:i" + (userConfig.enableSeconds ? ":S" : "") : flatpickr.defaultConfig.dateFormat + " H:i" + (userConfig.enableSeconds ? ":S" : "");
	        }
	
	        if (userConfig.altInput && (userConfig.enableTime || timeMode) && !userConfig.altFormat) {
	          formats$$1.altFormat = userConfig.noCalendar || timeMode ? "h:i" + (userConfig.enableSeconds ? ":S K" : " K") : flatpickr.defaultConfig.altFormat + (" h:i" + (userConfig.enableSeconds ? ":S" : "") + " K");
	        }
	
	        Object.defineProperty(self.config, "minDate", {
	          get: function get() {
	            return self.config._minDate;
	          },
	          set: minMaxDateSetter("min")
	        });
	        Object.defineProperty(self.config, "maxDate", {
	          get: function get() {
	            return self.config._maxDate;
	          },
	          set: minMaxDateSetter("max")
	        });
	
	        var minMaxTimeSetter = function minMaxTimeSetter(type) {
	          return function (val) {
	            self.config[type === "min" ? "_minTime" : "_maxTime"] = self.parseDate(val, "H:i");
	          };
	        };
	
	        Object.defineProperty(self.config, "minTime", {
	          get: function get() {
	            return self.config._minTime;
	          },
	          set: minMaxTimeSetter("min")
	        });
	        Object.defineProperty(self.config, "maxTime", {
	          get: function get() {
	            return self.config._maxTime;
	          },
	          set: minMaxTimeSetter("max")
	        });
	
	        if (userConfig.mode === "time") {
	          self.config.noCalendar = true;
	          self.config.enableTime = true;
	        }
	
	        Object.assign(self.config, formats$$1, userConfig);
	
	        for (var i = 0; i < boolOpts.length; i++) {
	          self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
	        }
	
	        HOOKS.filter(function (hook) {
	          return self.config[hook] !== undefined;
	        }).forEach(function (hook) {
	          self.config[hook] = arrayify(self.config[hook] || []).map(bindToInstance);
	        });
	        self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && !self.config.weekNumbers && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	
	        for (var _i = 0; _i < self.config.plugins.length; _i++) {
	          var pluginConf = self.config.plugins[_i](self) || {};
	
	          for (var key in pluginConf) {
	            if (HOOKS.indexOf(key) > -1) {
	              self.config[key] = arrayify(pluginConf[key]).map(bindToInstance).concat(self.config[key]);
	            } else if (typeof userConfig[key] === "undefined") self.config[key] = pluginConf[key];
	          }
	        }
	
	        triggerEvent("onParseConfig");
	      }
	
	      function setupLocale() {
	        if (typeof self.config.locale !== "object" && typeof flatpickr.l10ns[self.config.locale] === "undefined") self.config.errorHandler(new Error("flatpickr: invalid locale " + self.config.locale));
	        self.l10n = Object.assign({}, flatpickr.l10ns.default, typeof self.config.locale === "object" ? self.config.locale : self.config.locale !== "default" ? flatpickr.l10ns[self.config.locale] : undefined);
	        tokenRegex.K = "(" + self.l10n.amPM[0] + "|" + self.l10n.amPM[1] + "|" + self.l10n.amPM[0].toLowerCase() + "|" + self.l10n.amPM[1].toLowerCase() + ")";
	        self.formatDate = createDateFormatter(self);
	        self.parseDate = createDateParser({
	          config: self.config,
	          l10n: self.l10n
	        });
	      }
	
	      function positionCalendar(customPositionElement) {
	        if (self.calendarContainer === undefined) return;
	        triggerEvent("onPreCalendarPosition");
	        var positionElement = customPositionElement || self._positionElement;
	        var calendarHeight = Array.prototype.reduce.call(self.calendarContainer.children, function (acc, child) {
	          return acc + child.offsetHeight;
	        }, 0),
	            calendarWidth = self.calendarContainer.offsetWidth,
	            configPos = self.config.position.split(" "),
	            configPosVertical = configPos[0],
	            configPosHorizontal = configPos.length > 1 ? configPos[1] : null,
	            inputBounds = positionElement.getBoundingClientRect(),
	            distanceFromBottom = window.innerHeight - inputBounds.bottom,
	            showOnTop = configPosVertical === "above" || configPosVertical !== "below" && distanceFromBottom < calendarHeight && inputBounds.top > calendarHeight;
	        var top = window.pageYOffset + inputBounds.top + (!showOnTop ? positionElement.offsetHeight + 2 : -calendarHeight - 2);
	        toggleClass(self.calendarContainer, "arrowTop", !showOnTop);
	        toggleClass(self.calendarContainer, "arrowBottom", showOnTop);
	        if (self.config.inline) return;
	        var left = window.pageXOffset + inputBounds.left - (configPosHorizontal != null && configPosHorizontal === "center" ? (calendarWidth - inputBounds.width) / 2 : 0);
	        var right = window.document.body.offsetWidth - inputBounds.right;
	        var rightMost = left + calendarWidth > window.document.body.offsetWidth;
	        toggleClass(self.calendarContainer, "rightMost", rightMost);
	        if (self.config.static) return;
	        self.calendarContainer.style.top = top + "px";
	
	        if (!rightMost) {
	          self.calendarContainer.style.left = left + "px";
	          self.calendarContainer.style.right = "auto";
	        } else {
	          self.calendarContainer.style.left = "auto";
	          self.calendarContainer.style.right = right + "px";
	        }
	      }
	
	      function redraw() {
	        if (self.config.noCalendar || self.isMobile) return;
	        updateNavigationCurrentMonth();
	        buildDays();
	      }
	
	      function focusAndClose() {
	        self._input.focus();
	
	        if (window.navigator.userAgent.indexOf("MSIE") !== -1 || navigator.msMaxTouchPoints !== undefined) {
	          setTimeout(self.close, 0);
	        } else {
	          self.close();
	        }
	      }
	
	      function selectDate(e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        var isSelectable = function isSelectable(day) {
	          return day.classList && day.classList.contains("flatpickr-day") && !day.classList.contains("disabled") && !day.classList.contains("notAllowed");
	        };
	
	        var t = findParent(e.target, isSelectable);
	        if (t === undefined) return;
	        var target = t;
	        var selectedDate = self.latestSelectedDateObj = new Date(target.dateObj.getTime());
	        var shouldChangeMonth = (selectedDate.getMonth() < self.currentMonth || selectedDate.getMonth() > self.currentMonth + self.config.showMonths - 1) && self.config.mode !== "range";
	        self.selectedDateElem = target;
	        if (self.config.mode === "single") self.selectedDates = [selectedDate];else if (self.config.mode === "multiple") {
	          var selectedIndex = isDateSelected(selectedDate);
	          if (selectedIndex) self.selectedDates.splice(parseInt(selectedIndex), 1);else self.selectedDates.push(selectedDate);
	        } else if (self.config.mode === "range") {
	          if (self.selectedDates.length === 2) self.clear(false);
	          self.selectedDates.push(selectedDate);
	          if (compareDates(selectedDate, self.selectedDates[0], true) !== 0) self.selectedDates.sort(function (a, b) {
	            return a.getTime() - b.getTime();
	          });
	        }
	        setHoursFromInputs();
	
	        if (shouldChangeMonth) {
	          var isNewYear = self.currentYear !== selectedDate.getFullYear();
	          self.currentYear = selectedDate.getFullYear();
	          self.currentMonth = selectedDate.getMonth();
	          if (isNewYear) triggerEvent("onYearChange");
	          triggerEvent("onMonthChange");
	        }
	
	        updateNavigationCurrentMonth();
	        buildDays();
	        updateValue();
	        if (self.config.enableTime) setTimeout(function () {
	          return self.showTimeInput = true;
	        }, 50);
	        if (!shouldChangeMonth && self.config.mode !== "range" && self.config.showMonths === 1) focusOnDayElem(target);else self.selectedDateElem && self.selectedDateElem.focus();
	        if (self.hourElement !== undefined) setTimeout(function () {
	          return self.hourElement !== undefined && self.hourElement.select();
	        }, 451);
	
	        if (self.config.closeOnSelect) {
	          var single = self.config.mode === "single" && !self.config.enableTime;
	          var range = self.config.mode === "range" && self.selectedDates.length === 2 && !self.config.enableTime;
	
	          if (single || range) {
	            focusAndClose();
	          }
	        }
	
	        triggerChange();
	      }
	
	      var CALLBACKS = {
	        locale: [setupLocale, updateWeekdays],
	        showMonths: [buildMonths, setCalendarWidth, buildWeekdays]
	      };
	
	      function set(option, value) {
	        if (option !== null && typeof option === "object") Object.assign(self.config, option);else {
	          self.config[option] = value;
	          if (CALLBACKS[option] !== undefined) CALLBACKS[option].forEach(function (x) {
	            return x();
	          });else if (HOOKS.indexOf(option) > -1) self.config[option] = arrayify(value);
	        }
	        self.redraw();
	        jumpToDate();
	        updateValue(false);
	      }
	
	      function setSelectedDate(inputDate, format) {
	        var dates = [];
	        if (inputDate instanceof Array) dates = inputDate.map(function (d) {
	          return self.parseDate(d, format);
	        });else if (inputDate instanceof Date || typeof inputDate === "number") dates = [self.parseDate(inputDate, format)];else if (typeof inputDate === "string") {
	          switch (self.config.mode) {
	            case "single":
	            case "time":
	              dates = [self.parseDate(inputDate, format)];
	              break;
	
	            case "multiple":
	              dates = inputDate.split(self.config.conjunction).map(function (date) {
	                return self.parseDate(date, format);
	              });
	              break;
	
	            case "range":
	              dates = inputDate.split(self.l10n.rangeSeparator).map(function (date) {
	                return self.parseDate(date, format);
	              });
	              break;
	
	            default:
	              break;
	          }
	        } else self.config.errorHandler(new Error("Invalid date supplied: " + JSON.stringify(inputDate)));
	        self.selectedDates = dates.filter(function (d) {
	          return d instanceof Date && isEnabled(d, false);
	        });
	        if (self.config.mode === "range") self.selectedDates.sort(function (a, b) {
	          return a.getTime() - b.getTime();
	        });
	      }
	
	      function setDate(date, triggerChange, format) {
	        if (triggerChange === void 0) {
	          triggerChange = false;
	        }
	
	        if (format === void 0) {
	          format = self.config.dateFormat;
	        }
	
	        if (date !== 0 && !date || date instanceof Array && date.length === 0) return self.clear(triggerChange);
	        setSelectedDate(date, format);
	        self.showTimeInput = self.selectedDates.length > 0;
	        self.latestSelectedDateObj = self.selectedDates[0];
	        self.redraw();
	        jumpToDate();
	        setHoursFromDate();
	        updateValue(triggerChange);
	        if (triggerChange) triggerEvent("onChange");
	      }
	
	      function parseDateRules(arr) {
	        return arr.slice().map(function (rule) {
	          if (typeof rule === "string" || typeof rule === "number" || rule instanceof Date) {
	            return self.parseDate(rule, undefined, true);
	          } else if (rule && typeof rule === "object" && rule.from && rule.to) return {
	            from: self.parseDate(rule.from, undefined),
	            to: self.parseDate(rule.to, undefined)
	          };
	
	          return rule;
	        }).filter(function (x) {
	          return x;
	        });
	      }
	
	      function setupDates() {
	        self.selectedDates = [];
	        self.now = self.parseDate(self.config.now) || new Date();
	        var preloadedDate = self.config.defaultDate || ((self.input.nodeName === "INPUT" || self.input.nodeName === "TEXTAREA") && self.input.placeholder && self.input.value === self.input.placeholder ? null : self.input.value);
	        if (preloadedDate) setSelectedDate(preloadedDate, self.config.dateFormat);
	        var initialDate = self.selectedDates.length > 0 ? self.selectedDates[0] : self.config.minDate && self.config.minDate.getTime() > self.now.getTime() ? self.config.minDate : self.config.maxDate && self.config.maxDate.getTime() < self.now.getTime() ? self.config.maxDate : self.now;
	        self.currentYear = initialDate.getFullYear();
	        self.currentMonth = initialDate.getMonth();
	        if (self.selectedDates.length > 0) self.latestSelectedDateObj = self.selectedDates[0];
	        if (self.config.minTime !== undefined) self.config.minTime = self.parseDate(self.config.minTime, "H:i");
	        if (self.config.maxTime !== undefined) self.config.maxTime = self.parseDate(self.config.maxTime, "H:i");
	        self.minDateHasTime = !!self.config.minDate && (self.config.minDate.getHours() > 0 || self.config.minDate.getMinutes() > 0 || self.config.minDate.getSeconds() > 0);
	        self.maxDateHasTime = !!self.config.maxDate && (self.config.maxDate.getHours() > 0 || self.config.maxDate.getMinutes() > 0 || self.config.maxDate.getSeconds() > 0);
	        Object.defineProperty(self, "showTimeInput", {
	          get: function get() {
	            return self._showTimeInput;
	          },
	          set: function set(bool) {
	            self._showTimeInput = bool;
	            if (self.calendarContainer) toggleClass(self.calendarContainer, "showTimeInput", bool);
	            self.isOpen && positionCalendar();
	          }
	        });
	      }
	
	      function setupInputs() {
	        self.input = self.config.wrap ? element.querySelector("[data-input]") : element;
	
	        if (!self.input) {
	          self.config.errorHandler(new Error("Invalid input element specified"));
	          return;
	        }
	
	        self.input._type = self.input.type;
	        self.input.type = "text";
	        self.input.classList.add("flatpickr-input");
	        self._input = self.input;
	
	        if (self.config.altInput) {
	          self.altInput = createElement(self.input.nodeName, self.input.className + " " + self.config.altInputClass);
	          self._input = self.altInput;
	          self.altInput.placeholder = self.input.placeholder;
	          self.altInput.disabled = self.input.disabled;
	          self.altInput.required = self.input.required;
	          self.altInput.tabIndex = self.input.tabIndex;
	          self.altInput.type = "text";
	          self.input.setAttribute("type", "hidden");
	          if (!self.config.static && self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
	        }
	
	        if (!self.config.allowInput) self._input.setAttribute("readonly", "readonly");
	        self._positionElement = self.config.positionElement || self._input;
	      }
	
	      function setupMobile() {
	        var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
	        self.mobileInput = createElement("input", self.input.className + " flatpickr-mobile");
	        self.mobileInput.step = self.input.getAttribute("step") || "any";
	        self.mobileInput.tabIndex = 1;
	        self.mobileInput.type = inputType;
	        self.mobileInput.disabled = self.input.disabled;
	        self.mobileInput.required = self.input.required;
	        self.mobileInput.placeholder = self.input.placeholder;
	        self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
	
	        if (self.selectedDates.length > 0) {
	          self.mobileInput.defaultValue = self.mobileInput.value = self.formatDate(self.selectedDates[0], self.mobileFormatStr);
	        }
	
	        if (self.config.minDate) self.mobileInput.min = self.formatDate(self.config.minDate, "Y-m-d");
	        if (self.config.maxDate) self.mobileInput.max = self.formatDate(self.config.maxDate, "Y-m-d");
	        self.input.type = "hidden";
	        if (self.altInput !== undefined) self.altInput.type = "hidden";
	
	        try {
	          if (self.input.parentNode) self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
	        } catch (_a) {}
	
	        bind(self.mobileInput, "change", function (e) {
	          self.setDate(e.target.value, false, self.mobileFormatStr);
	          triggerEvent("onChange");
	          triggerEvent("onClose");
	        });
	      }
	
	      function toggle(e) {
	        if (self.isOpen === true) return self.close();
	        self.open(e);
	      }
	
	      function triggerEvent(event, data) {
	        if (self.config === undefined) return;
	        var hooks = self.config[event];
	
	        if (hooks !== undefined && hooks.length > 0) {
	          for (var i = 0; hooks[i] && i < hooks.length; i++) {
	            hooks[i](self.selectedDates, self.input.value, self, data);
	          }
	        }
	
	        if (event === "onChange") {
	          self.input.dispatchEvent(createEvent("change"));
	          self.input.dispatchEvent(createEvent("input"));
	        }
	      }
	
	      function createEvent(name) {
	        var e = document.createEvent("Event");
	        e.initEvent(name, true, true);
	        return e;
	      }
	
	      function isDateSelected(date) {
	        for (var i = 0; i < self.selectedDates.length; i++) {
	          if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
	        }
	
	        return false;
	      }
	
	      function isDateInRange(date) {
	        if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
	        return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
	      }
	
	      function updateNavigationCurrentMonth() {
	        if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
	        self.yearElements.forEach(function (yearElement, i) {
	          var d = new Date(self.currentYear, self.currentMonth, 1);
	          d.setMonth(self.currentMonth + i);
	          self.monthElements[i].textContent = monthToStr(d.getMonth(), self.config.shorthandCurrentMonth, self.l10n) + " ";
	          yearElement.value = d.getFullYear().toString();
	        });
	        self._hidePrevMonthArrow = self.config.minDate !== undefined && (self.currentYear === self.config.minDate.getFullYear() ? self.currentMonth <= self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear());
	        self._hideNextMonthArrow = self.config.maxDate !== undefined && (self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear());
	      }
	
	      function getDateStr(format) {
	        return self.selectedDates.map(function (dObj) {
	          return self.formatDate(dObj, format);
	        }).filter(function (d, i, arr) {
	          return self.config.mode !== "range" || self.config.enableTime || arr.indexOf(d) === i;
	        }).join(self.config.mode !== "range" ? self.config.conjunction : self.l10n.rangeSeparator);
	      }
	
	      function updateValue(triggerChange) {
	        if (triggerChange === void 0) {
	          triggerChange = true;
	        }
	
	        if (self.selectedDates.length === 0) return self.clear(triggerChange);
	
	        if (self.mobileInput !== undefined && self.mobileFormatStr) {
	          self.mobileInput.value = self.latestSelectedDateObj !== undefined ? self.formatDate(self.latestSelectedDateObj, self.mobileFormatStr) : "";
	        }
	
	        self.input.value = getDateStr(self.config.dateFormat);
	
	        if (self.altInput !== undefined) {
	          self.altInput.value = getDateStr(self.config.altFormat);
	        }
	
	        if (triggerChange !== false) triggerEvent("onValueUpdate");
	      }
	
	      function onMonthNavClick(e) {
	        e.preventDefault();
	        var isPrevMonth = self.prevMonthNav.contains(e.target);
	        var isNextMonth = self.nextMonthNav.contains(e.target);
	
	        if (isPrevMonth || isNextMonth) {
	          changeMonth(isPrevMonth ? -1 : 1);
	        } else if (self.yearElements.indexOf(e.target) >= 0) {
	          e.target.select();
	        } else if (e.target.classList.contains("arrowUp")) {
	          self.changeYear(self.currentYear + 1);
	        } else if (e.target.classList.contains("arrowDown")) {
	          self.changeYear(self.currentYear - 1);
	        }
	      }
	
	      function timeWrapper(e) {
	        e.preventDefault();
	        var isKeyDown = e.type === "keydown",
	            input = e.target;
	
	        if (self.amPM !== undefined && e.target === self.amPM) {
	          self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	        }
	
	        var min = parseFloat(input.getAttribute("data-min")),
	            max = parseFloat(input.getAttribute("data-max")),
	            step = parseFloat(input.getAttribute("data-step")),
	            curValue = parseInt(input.value, 10),
	            delta = e.delta || (isKeyDown ? e.which === 38 ? 1 : -1 : 0);
	        var newValue = curValue + step * delta;
	
	        if (typeof input.value !== "undefined" && input.value.length === 2) {
	          var isHourElem = input === self.hourElement,
	              isMinuteElem = input === self.minuteElement;
	
	          if (newValue < min) {
	            newValue = max + newValue + int(!isHourElem) + (int(isHourElem) && int(!self.amPM));
	            if (isMinuteElem) incrementNumInput(undefined, -1, self.hourElement);
	          } else if (newValue > max) {
	            newValue = input === self.hourElement ? newValue - max - int(!self.amPM) : min;
	            if (isMinuteElem) incrementNumInput(undefined, 1, self.hourElement);
	          }
	
	          if (self.amPM && isHourElem && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) {
	            self.amPM.textContent = self.l10n.amPM[int(self.amPM.textContent === self.l10n.amPM[0])];
	          }
	
	          input.value = pad(newValue);
	        }
	      }
	
	      init();
	      return self;
	    }
	
	    function _flatpickr(nodeList, config) {
	      var nodes = Array.prototype.slice.call(nodeList);
	      var instances = [];
	
	      for (var i = 0; i < nodes.length; i++) {
	        var node = nodes[i];
	
	        try {
	          if (node.getAttribute("data-fp-omit") !== null) continue;
	
	          if (node._flatpickr !== undefined) {
	            node._flatpickr.destroy();
	
	            node._flatpickr = undefined;
	          }
	
	          node._flatpickr = FlatpickrInstance(node, config || {});
	          instances.push(node._flatpickr);
	        } catch (e) {
	          console.error(e);
	        }
	      }
	
	      return instances.length === 1 ? instances[0] : instances;
	    }
	
	    if (typeof HTMLElement !== "undefined") {
	      HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
	        return _flatpickr(this, config);
	      };
	
	      HTMLElement.prototype.flatpickr = function (config) {
	        return _flatpickr([this], config);
	      };
	    }
	
	    var flatpickr = function flatpickr(selector, config) {
	      if (selector instanceof NodeList) return _flatpickr(selector, config);else if (typeof selector === "string") return _flatpickr(window.document.querySelectorAll(selector), config);
	      return _flatpickr([selector], config);
	    };
	
	    flatpickr.defaultConfig = defaults;
	    flatpickr.l10ns = {
	      en: Object.assign({}, english),
	      default: Object.assign({}, english)
	    };
	
	    flatpickr.localize = function (l10n) {
	      flatpickr.l10ns.default = Object.assign({}, flatpickr.l10ns.default, l10n);
	    };
	
	    flatpickr.setDefaults = function (config) {
	      flatpickr.defaultConfig = Object.assign({}, flatpickr.defaultConfig, config);
	    };
	
	    flatpickr.parseDate = createDateParser({});
	    flatpickr.formatDate = createDateFormatter({});
	    flatpickr.compareDates = compareDates;
	
	    if (typeof jQuery !== "undefined") {
	      jQuery.fn.flatpickr = function (config) {
	        return _flatpickr(this, config);
	      };
	    }
	
	    Date.prototype.fp_incr = function (days) {
	      return new Date(this.getFullYear(), this.getMonth(), this.getDate() + (typeof days === "string" ? parseInt(days, 10) : days));
	    };
	
	    if (typeof window !== "undefined") {
	      window.flatpickr = flatpickr;
	    }
	
	    return flatpickr;
	
	})));


/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

	/* flatpickr v4.5.2, @license MIT */
	(function (global, factory) {
	     true ? factory(exports) :
	    typeof define === 'function' && define.amd ? define(['exports'], factory) :
	    (factory((global.nl = {})));
	}(this, (function (exports) { 'use strict';
	
	    var fp = typeof window !== "undefined" && window.flatpickr !== undefined ? window.flatpickr : {
	      l10ns: {}
	    };
	    var Dutch = {
	      weekdays: {
	        shorthand: ["zo", "ma", "di", "wo", "do", "vr", "za"],
	        longhand: ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"]
	      },
	      months: {
	        shorthand: ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sept", "okt", "nov", "dec"],
	        longhand: ["januari", "februari", "maart", "april", "mei", "juni", "juli", "augustus", "september", "oktober", "november", "december"]
	      },
	      firstDayOfWeek: 1,
	      weekAbbreviation: "wk",
	      rangeSeparator: " tot ",
	      scrollTitle: "Scroll voor volgende / vorige",
	      toggleTitle: "Klik om te wisselen",
	      ordinal: function ordinal(nth) {
	        if (nth === 1 || nth === 8 || nth >= 20) return "ste";
	        return "de";
	      }
	    };
	    fp.l10ns.nl = Dutch;
	    var nl = fp.l10ns;
	
	    exports.Dutch = Dutch;
	    exports.default = nl;
	
	    Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 176:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 91:
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(98);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),

/***/ 92:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(33),
	    getRawTag = __webpack_require__(95),
	    objectToString = __webpack_require__(96);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),

/***/ 93:
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 94:
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(97);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),

/***/ 95:
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(33);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),

/***/ 96:
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),

/***/ 97:
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(93);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),

/***/ 99:
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(92),
	    getPrototype = __webpack_require__(94),
	    isObjectLike = __webpack_require__(99);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),

/***/ 198:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _flatpickr = __webpack_require__(178);
	
	var _flatpickr2 = _interopRequireDefault(_flatpickr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var hooks = ['onChange', 'onOpen', 'onClose', 'onMonthChange', 'onYearChange', 'onReady', 'onValueUpdate', 'onDayCreate'];
	
	var DateTimePicker = function (_Component) {
	  _inherits(DateTimePicker, _Component);
	
	  function DateTimePicker() {
	    _classCallCheck(this, DateTimePicker);
	
	    return _possibleConstructorReturn(this, (DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).apply(this, arguments));
	  }
	
	  _createClass(DateTimePicker, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var _this2 = this;
	
	      var options = props.options;
	
	      var prevOptions = this.props.options;
	
	      // Add prop hooks to options
	      hooks.forEach(function (hook) {
	        if (props.hasOwnProperty(hook)) {
	          options[hook] = props[hook];
	        }
	        // Add prev ones too so we can compare against them later
	        if (_this2.props.hasOwnProperty(hook)) {
	          prevOptions[hook] = _this2.props[hook];
	        }
	      });
	
	      var optionsKeys = Object.getOwnPropertyNames(options);
	
	      for (var index = optionsKeys.length - 1; index >= 0; index--) {
	        var key = optionsKeys[index];
	        var value = options[key];
	
	        if (value !== prevOptions[key]) {
	          // Hook handlers must be set as an array
	          if (hooks.indexOf(key) !== -1 && !Array.isArray(value)) {
	            value = [value];
	          }
	
	          this.flatpickr.set(key, value);
	        }
	      }
	
	      if (props.hasOwnProperty('value') && props.value !== this.props.value) {
	        this.flatpickr.setDate(props.value, false);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var options = _extends({
	        onClose: function onClose() {
	          _this3.node.blur && _this3.node.blur();
	        }
	      }, this.props.options);
	
	      // Add prop hooks to options
	      hooks.forEach(function (hook) {
	        if (_this3.props[hook]) {
	          options[hook] = _this3.props[hook];
	        }
	      });
	
	      this.flatpickr = new _flatpickr2.default(this.node, options);
	
	      if (this.props.hasOwnProperty('value')) {
	        this.flatpickr.setDate(this.props.value, false);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.flatpickr.destroy();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      // eslint-disable-next-line no-unused-vars
	      var _props = this.props,
	          options = _props.options,
	          defaultValue = _props.defaultValue,
	          value = _props.value,
	          children = _props.children,
	          props = _objectWithoutProperties(_props, ['options', 'defaultValue', 'value', 'children']);
	
	      // Don't pass hooks to dom node
	
	
	      hooks.forEach(function (hook) {
	        delete props[hook];
	      });
	
	      return options.wrap ? _react2.default.createElement(
	        'div',
	        _extends({}, props, { ref: function ref(node) {
	            _this4.node = node;
	          } }),
	        children
	      ) : _react2.default.createElement('input', _extends({}, props, { defaultValue: defaultValue,
	        ref: function ref(node) {
	          _this4.node = node;
	        } }));
	    }
	  }]);
	
	  return DateTimePicker;
	}(_react.Component);
	
	DateTimePicker.propTypes = {
	  defaultValue: _propTypes2.default.string,
	  options: _propTypes2.default.object,
	  onChange: _propTypes2.default.func,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func,
	  onMonthChange: _propTypes2.default.func,
	  onYearChange: _propTypes2.default.func,
	  onReady: _propTypes2.default.func,
	  onValueUpdate: _propTypes2.default.func,
	  onDayCreate: _propTypes2.default.func,
	  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.number]),
	  children: _propTypes2.default.node
	};
	DateTimePicker.defaultProps = {
	  options: {}
	};
	exports.default = DateTimePicker;

/***/ }),

/***/ 508:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _utils = __webpack_require__(509);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var propTypes = {
	  thousandSeparator: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.oneOf([true])]),
	  decimalSeparator: _propTypes.default.string,
	  decimalScale: _propTypes.default.number,
	  fixedDecimalScale: _propTypes.default.bool,
	  displayType: _propTypes.default.oneOf(['input', 'text']),
	  prefix: _propTypes.default.string,
	  suffix: _propTypes.default.string,
	  format: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	  removeFormatting: _propTypes.default.func,
	  mask: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.arrayOf(_propTypes.default.string)]),
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	  isNumericString: _propTypes.default.bool,
	  customInput: _propTypes.default.func,
	  allowNegative: _propTypes.default.bool,
	  allowEmptyFormatting: _propTypes.default.bool,
	  onValueChange: _propTypes.default.func,
	  onKeyDown: _propTypes.default.func,
	  onMouseUp: _propTypes.default.func,
	  onChange: _propTypes.default.func,
	  onFocus: _propTypes.default.func,
	  onBlur: _propTypes.default.func,
	  type: _propTypes.default.oneOf(['text', 'tel']),
	  isAllowed: _propTypes.default.func,
	  renderText: _propTypes.default.func,
	  getInputRef: _propTypes.default.func
	};
	var defaultProps = {
	  displayType: 'input',
	  decimalSeparator: '.',
	  fixedDecimalScale: false,
	  prefix: '',
	  suffix: '',
	  allowNegative: true,
	  allowEmptyFormatting: false,
	  isNumericString: false,
	  type: 'text',
	  onValueChange: _utils.noop,
	  onChange: _utils.noop,
	  onKeyDown: _utils.noop,
	  onMouseUp: _utils.noop,
	  onFocus: _utils.noop,
	  onBlur: _utils.noop,
	  isAllowed: _utils.returnTrue,
	  getInputRef: _utils.noop
	};
	
	var NumberFormat =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(NumberFormat, _React$Component);
	
	  function NumberFormat(props) {
	    var _this;
	
	    _classCallCheck(this, NumberFormat);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(NumberFormat).call(this, props)); //validate props
	
	    _this.validateProps();
	
	    var formattedValue = _this.formatValueProp();
	
	    _this.state = {
	      value: formattedValue,
	      numAsString: _this.removeFormatting(formattedValue)
	    };
	    _this.selectionBeforeInput = {
	      selectionStart: 0,
	      selectionEnd: 0
	    };
	    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onMouseUp = _this.onMouseUp.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onFocus = _this.onFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    _this.onBlur = _this.onBlur.bind(_assertThisInitialized(_assertThisInitialized(_this)));
	    return _this;
	  }
	
	  _createClass(NumberFormat, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.updateValueIfRequired(prevProps);
	    }
	  }, {
	    key: "updateValueIfRequired",
	    value: function updateValueIfRequired(prevProps) {
	      var props = this.props,
	          state = this.state;
	
	      if (prevProps !== props) {
	        //validate props
	        this.validateProps();
	        var stateValue = state.value;
	        var lastNumStr = state.numAsString || '';
	        var lastValueWithNewFormat = this.formatNumString(lastNumStr);
	        var formattedValue = props.value === undefined ? lastValueWithNewFormat : this.formatValueProp();
	        var numAsString = this.removeFormatting(formattedValue);
	        var floatValue = parseFloat(numAsString);
	        var lastFloatValue = parseFloat(lastNumStr);
	
	        if ((!isNaN(floatValue) || !isNaN(lastFloatValue)) && floatValue !== lastFloatValue || lastValueWithNewFormat !== stateValue) {
	          this.setState({
	            value: formattedValue,
	            numAsString: numAsString
	          });
	        }
	      }
	    }
	    /** Misc methods **/
	
	  }, {
	    key: "getFloatString",
	    value: function getFloatString() {
	      var num = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var decimalScale = this.props.decimalScale;
	
	      var _this$getSeparators = this.getSeparators(),
	          decimalSeparator = _this$getSeparators.decimalSeparator;
	
	      var numRegex = this.getNumberRegex(true); //remove negation for regex check
	
	      var hasNegation = num[0] === '-';
	      if (hasNegation) num = num.replace('-', ''); //if decimal scale is zero remove decimal and number after decimalSeparator
	
	      if (decimalSeparator && decimalScale === 0) {
	        num = num.split(decimalSeparator)[0];
	      }
	
	      num = (num.match(numRegex) || []).join('').replace(decimalSeparator, '.'); //remove extra decimals
	
	      var firstDecimalIndex = num.indexOf('.');
	
	      if (firstDecimalIndex !== -1) {
	        num = "".concat(num.substring(0, firstDecimalIndex), ".").concat(num.substring(firstDecimalIndex + 1, num.length).replace(new RegExp((0, _utils.escapeRegExp)(decimalSeparator), 'g'), ''));
	      } //add negation back
	
	
	      if (hasNegation) num = '-' + num;
	      return num;
	    } //returned regex assumes decimalSeparator is as per prop
	
	  }, {
	    key: "getNumberRegex",
	    value: function getNumberRegex(g, ignoreDecimalSeparator) {
	      var _this$props = this.props,
	          format = _this$props.format,
	          decimalScale = _this$props.decimalScale;
	
	      var _this$getSeparators2 = this.getSeparators(),
	          decimalSeparator = _this$getSeparators2.decimalSeparator;
	
	      return new RegExp('\\d' + (decimalSeparator && decimalScale !== 0 && !ignoreDecimalSeparator && !format ? '|' + (0, _utils.escapeRegExp)(decimalSeparator) : ''), g ? 'g' : undefined);
	    }
	  }, {
	    key: "getSeparators",
	    value: function getSeparators() {
	      var decimalSeparator = this.props.decimalSeparator;
	      var thousandSeparator = this.props.thousandSeparator;
	
	      if (thousandSeparator === true) {
	        thousandSeparator = ',';
	      }
	
	      return {
	        decimalSeparator: decimalSeparator,
	        thousandSeparator: thousandSeparator
	      };
	    }
	  }, {
	    key: "getMaskAtIndex",
	    value: function getMaskAtIndex(index) {
	      var _this$props$mask = this.props.mask,
	          mask = _this$props$mask === void 0 ? ' ' : _this$props$mask;
	
	      if (typeof mask === 'string') {
	        return mask;
	      }
	
	      return mask[index] || ' ';
	    }
	  }, {
	    key: "getValueObject",
	    value: function getValueObject(formattedValue, numAsString) {
	      var floatValue = parseFloat(numAsString);
	      return {
	        formattedValue: formattedValue,
	        value: numAsString,
	        floatValue: isNaN(floatValue) ? undefined : floatValue
	      };
	    }
	  }, {
	    key: "validateProps",
	    value: function validateProps() {
	      var mask = this.props.mask; //validate decimalSeparator and thousandSeparator
	
	      var _this$getSeparators3 = this.getSeparators(),
	          decimalSeparator = _this$getSeparators3.decimalSeparator,
	          thousandSeparator = _this$getSeparators3.thousandSeparator;
	
	      if (decimalSeparator === thousandSeparator) {
	        throw new Error("\n          Decimal separator can't be same as thousand separator.\n          thousandSeparator: ".concat(thousandSeparator, " (thousandSeparator = {true} is same as thousandSeparator = \",\")\n          decimalSeparator: ").concat(decimalSeparator, " (default value for decimalSeparator is .)\n       "));
	      } //validate mask
	
	
	      if (mask) {
	        var maskAsStr = mask === 'string' ? mask : mask.toString();
	
	        if (maskAsStr.match(/\d/g)) {
	          throw new Error("\n          Mask ".concat(mask, " should not contain numeric character;\n        "));
	        }
	      }
	    }
	    /** Misc methods end **/
	
	    /** caret specific methods **/
	
	  }, {
	    key: "setPatchedCaretPosition",
	    value: function setPatchedCaretPosition(el, caretPos, currentValue) {
	      /* setting caret position within timeout of 0ms is required for mobile chrome,
	      otherwise browser resets the caret position after we set it
	      We are also setting it without timeout so that in normal browser we don't see the flickering */
	      (0, _utils.setCaretPosition)(el, caretPos);
	      setTimeout(function () {
	        if (el.value === currentValue) (0, _utils.setCaretPosition)(el, caretPos);
	      }, 0);
	    }
	    /* This keeps the caret within typing area so people can't type in between prefix or suffix */
	
	  }, {
	    key: "correctCaretPosition",
	    value: function correctCaretPosition(value, caretPos, direction) {
	      var _this$props2 = this.props,
	          prefix = _this$props2.prefix,
	          suffix = _this$props2.suffix,
	          format = _this$props2.format; //if value is empty return 0
	
	      if (value === '') return 0; //caret position should be between 0 and value length
	
	      caretPos = (0, _utils.clamp)(caretPos, 0, value.length); //in case of format as number limit between prefix and suffix
	
	      if (!format) {
	        var hasNegation = value[0] === '-';
	        return (0, _utils.clamp)(caretPos, prefix.length + (hasNegation ? 1 : 0), value.length - suffix.length);
	      } //in case if custom format method don't do anything
	
	
	      if (typeof format === 'function') return caretPos;
	      /* in case format is string find the closest # position from the caret position */
	      //in case the caretPos have input value on it don't do anything
	
	      if (format[caretPos] === '#' && (0, _utils.charIsNumber)(value[caretPos])) return caretPos; //if caretPos is just after input value don't do anything
	
	      if (format[caretPos - 1] === '#' && (0, _utils.charIsNumber)(value[caretPos - 1])) return caretPos; //find the nearest caret position
	
	      var firstHashPosition = format.indexOf('#');
	      var lastHashPosition = format.lastIndexOf('#'); //limit the cursor between the first # position and the last # position
	
	      caretPos = (0, _utils.clamp)(caretPos, firstHashPosition, lastHashPosition + 1);
	      var nextPos = format.substring(caretPos, format.length).indexOf('#');
	      var caretLeftBound = caretPos;
	      var caretRightBound = caretPos + (nextPos === -1 ? 0 : nextPos); //get the position where the last number is present
	
	      while (caretLeftBound > firstHashPosition && (format[caretLeftBound] !== '#' || !(0, _utils.charIsNumber)(value[caretLeftBound]))) {
	        caretLeftBound -= 1;
	      }
	
	      var goToLeft = !(0, _utils.charIsNumber)(value[caretRightBound]) || direction === 'left' && caretPos !== firstHashPosition || caretPos - caretLeftBound < caretRightBound - caretPos;
	
	      if (goToLeft) {
	        //check if number should be taken after the bound or after it
	        //if number preceding a valid number keep it after
	        return (0, _utils.charIsNumber)(value[caretLeftBound]) ? caretLeftBound + 1 : caretLeftBound;
	      }
	
	      return caretRightBound;
	    }
	  }, {
	    key: "getCaretPosition",
	    value: function getCaretPosition(inputValue, formattedValue, caretPos) {
	      var format = this.props.format;
	      var stateValue = this.state.value;
	      var numRegex = this.getNumberRegex(true);
	      var inputNumber = (inputValue.match(numRegex) || []).join('');
	      var formattedNumber = (formattedValue.match(numRegex) || []).join('');
	      var j, i;
	      j = 0;
	
	      for (i = 0; i < caretPos; i++) {
	        var currentInputChar = inputValue[i] || '';
	        var currentFormatChar = formattedValue[j] || ''; //no need to increase new cursor position if formatted value does not have those characters
	        //case inputValue = 1a23 and formattedValue =  123
	
	        if (!currentInputChar.match(numRegex) && currentInputChar !== currentFormatChar) continue; //When we are striping out leading zeros maintain the new cursor position
	        //Case inputValue = 00023 and formattedValue = 23;
	
	        if (currentInputChar === '0' && currentFormatChar.match(numRegex) && currentFormatChar !== '0' && inputNumber.length !== formattedNumber.length) continue; //we are not using currentFormatChar because j can change here
	
	        while (currentInputChar !== formattedValue[j] && j < formattedValue.length) {
	          j++;
	        }
	
	        j++;
	      }
	
	      if (typeof format === 'string' && !stateValue) {
	        //set it to the maximum value so it goes after the last number
	        j = formattedValue.length;
	      } //correct caret position if its outside of editable area
	
	
	      j = this.correctCaretPosition(formattedValue, j);
	      return j;
	    }
	    /** caret specific methods ends **/
	
	    /** methods to remove formattting **/
	
	  }, {
	    key: "removePrefixAndSuffix",
	    value: function removePrefixAndSuffix(val) {
	      var _this$props3 = this.props,
	          format = _this$props3.format,
	          prefix = _this$props3.prefix,
	          suffix = _this$props3.suffix; //remove prefix and suffix
	
	      if (!format && val) {
	        var isNegative = val[0] === '-'; //remove negation sign
	
	        if (isNegative) val = val.substring(1, val.length); //remove prefix
	
	        val = prefix && val.indexOf(prefix) === 0 ? val.substring(prefix.length, val.length) : val; //remove suffix
	
	        var suffixLastIndex = val.lastIndexOf(suffix);
	        val = suffix && suffixLastIndex !== -1 && suffixLastIndex === val.length - suffix.length ? val.substring(0, suffixLastIndex) : val; //add negation sign back
	
	        if (isNegative) val = '-' + val;
	      }
	
	      return val;
	    }
	  }, {
	    key: "removePatternFormatting",
	    value: function removePatternFormatting(val) {
	      var format = this.props.format;
	      var formatArray = format.split('#').filter(function (str) {
	        return str !== '';
	      });
	      var start = 0;
	      var numStr = '';
	
	      for (var i = 0, ln = formatArray.length; i <= ln; i++) {
	        var part = formatArray[i] || ''; //if i is the last fragment take the index of end of the value
	        //For case like +1 (911) 911 91 91 having pattern +1 (###) ### ## ##
	
	        var index = i === ln ? val.length : val.indexOf(part, start);
	        /* in any case if we don't find the pattern part in the value assume the val as numeric string
	        This will be also in case if user has started typing, in any other case it will not be -1
	        unless wrong prop value is provided */
	
	        if (index === -1) {
	          numStr = val;
	          break;
	        } else {
	          numStr += val.substring(start, index);
	          start = index + part.length;
	        }
	      }
	
	      return (numStr.match(/\d/g) || []).join('');
	    }
	  }, {
	    key: "removeFormatting",
	    value: function removeFormatting(val) {
	      var _this$props4 = this.props,
	          format = _this$props4.format,
	          removeFormatting = _this$props4.removeFormatting;
	      if (!val) return val;
	
	      if (!format) {
	        val = this.removePrefixAndSuffix(val);
	        val = this.getFloatString(val);
	      } else if (typeof format === 'string') {
	        val = this.removePatternFormatting(val);
	      } else if (typeof removeFormatting === 'function') {
	        //condition need to be handled if format method is provide,
	        val = removeFormatting(val);
	      } else {
	        val = (val.match(/\d/g) || []).join('');
	      }
	
	      return val;
	    }
	    /** methods to remove formattting end **/
	
	    /*** format specific methods start ***/
	
	    /**
	     * Format when # based string is provided
	     * @param  {string} numStr Numeric String
	     * @return {string}        formatted Value
	     */
	
	  }, {
	    key: "formatWithPattern",
	    value: function formatWithPattern(numStr) {
	      var format = this.props.format;
	      var hashCount = 0;
	      var formattedNumberAry = format.split('');
	
	      for (var i = 0, ln = format.length; i < ln; i++) {
	        if (format[i] === '#') {
	          formattedNumberAry[i] = numStr[hashCount] || this.getMaskAtIndex(hashCount);
	          hashCount += 1;
	        }
	      }
	
	      return formattedNumberAry.join('');
	    }
	    /**
	     * @param  {string} numStr Numeric string/floatString] It always have decimalSeparator as .
	     * @return {string} formatted Value
	     */
	
	  }, {
	    key: "formatAsNumber",
	    value: function formatAsNumber(numStr) {
	      var _this$props5 = this.props,
	          decimalScale = _this$props5.decimalScale,
	          fixedDecimalScale = _this$props5.fixedDecimalScale,
	          prefix = _this$props5.prefix,
	          suffix = _this$props5.suffix,
	          allowNegative = _this$props5.allowNegative;
	
	      var _this$getSeparators4 = this.getSeparators(),
	          thousandSeparator = _this$getSeparators4.thousandSeparator,
	          decimalSeparator = _this$getSeparators4.decimalSeparator;
	
	      var hasDecimalSeparator = numStr.indexOf('.') !== -1 || decimalScale && fixedDecimalScale;
	
	      var _splitDecimal = (0, _utils.splitDecimal)(numStr, allowNegative),
	          beforeDecimal = _splitDecimal.beforeDecimal,
	          afterDecimal = _splitDecimal.afterDecimal,
	          addNegation = _splitDecimal.addNegation; // eslint-disable-line prefer-const
	      //apply decimal precision if its defined
	
	
	      if (decimalScale !== undefined) afterDecimal = (0, _utils.limitToScale)(afterDecimal, decimalScale, fixedDecimalScale);
	
	      if (thousandSeparator) {
	        beforeDecimal = beforeDecimal.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousandSeparator);
	      } //add prefix and suffix
	
	
	      if (prefix) beforeDecimal = prefix + beforeDecimal;
	      if (suffix) afterDecimal = afterDecimal + suffix; //restore negation sign
	
	      if (addNegation) beforeDecimal = '-' + beforeDecimal;
	      numStr = beforeDecimal + (hasDecimalSeparator && decimalSeparator || '') + afterDecimal;
	      return numStr;
	    }
	  }, {
	    key: "formatNumString",
	    value: function formatNumString() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var _this$props6 = this.props,
	          format = _this$props6.format,
	          allowEmptyFormatting = _this$props6.allowEmptyFormatting;
	      var formattedValue = value;
	
	      if (value === '' && !allowEmptyFormatting) {
	        formattedValue = '';
	      } else if (value === '-' && !format) {
	        formattedValue = '-';
	        value = '';
	      } else if (typeof format === 'string') {
	        formattedValue = this.formatWithPattern(formattedValue);
	      } else if (typeof format === 'function') {
	        formattedValue = format(formattedValue);
	      } else {
	        formattedValue = this.formatAsNumber(formattedValue);
	      }
	
	      return formattedValue;
	    }
	  }, {
	    key: "formatValueProp",
	    value: function formatValueProp() {
	      var _this$props7 = this.props,
	          format = _this$props7.format,
	          decimalScale = _this$props7.decimalScale,
	          fixedDecimalScale = _this$props7.fixedDecimalScale,
	          allowEmptyFormatting = _this$props7.allowEmptyFormatting;
	      var _this$props8 = this.props,
	          value = _this$props8.value,
	          isNumericString = _this$props8.isNumericString;
	      var isNonNumericFalsy = !value && value !== 0;
	
	      if (isNonNumericFalsy && allowEmptyFormatting) {
	        value = '';
	      } // if value is not defined return empty string
	
	
	      if (isNonNumericFalsy && !allowEmptyFormatting) return '';
	
	      if (typeof value === 'number') {
	        value = value.toString();
	        isNumericString = true;
	      } //round the number based on decimalScale
	      //format only if non formatted value is provided
	
	
	      if (isNumericString && !format && typeof decimalScale === 'number') {
	        value = (0, _utils.roundToPrecision)(value, decimalScale, fixedDecimalScale);
	      }
	
	      var formattedValue = isNumericString ? this.formatNumString(value) : this.formatInput(value);
	      return formattedValue;
	    }
	  }, {
	    key: "formatNegation",
	    value: function formatNegation() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var allowNegative = this.props.allowNegative;
	      var negationRegex = new RegExp('(-)');
	      var doubleNegationRegex = new RegExp('(-)(.)*(-)'); // Check number has '-' value
	
	      var hasNegation = negationRegex.test(value); // Check number has 2 or more '-' values
	
	      var removeNegation = doubleNegationRegex.test(value); //remove negation
	
	      value = value.replace(/-/g, '');
	
	      if (hasNegation && !removeNegation && allowNegative) {
	        value = '-' + value;
	      }
	
	      return value;
	    }
	  }, {
	    key: "formatInput",
	    value: function formatInput() {
	      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	      var format = this.props.format; //format negation only if we are formatting as number
	
	      if (!format) {
	        value = this.formatNegation(value);
	      } //remove formatting from number
	
	
	      value = this.removeFormatting(value);
	      return this.formatNumString(value);
	    }
	    /*** format specific methods end ***/
	
	  }, {
	    key: "isCharacterAFormat",
	    value: function isCharacterAFormat(caretPos, value) {
	      var _this$props9 = this.props,
	          format = _this$props9.format,
	          prefix = _this$props9.prefix,
	          suffix = _this$props9.suffix,
	          decimalScale = _this$props9.decimalScale,
	          fixedDecimalScale = _this$props9.fixedDecimalScale;
	
	      var _this$getSeparators5 = this.getSeparators(),
	          decimalSeparator = _this$getSeparators5.decimalSeparator; //check within format pattern
	
	
	      if (typeof format === 'string' && format[caretPos] !== '#') return true; //check in number format
	
	      if (!format && (caretPos < prefix.length || caretPos >= value.length - suffix.length || decimalScale && fixedDecimalScale && value[caretPos] === decimalSeparator)) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "checkIfFormatGotDeleted",
	    value: function checkIfFormatGotDeleted(start, end, value) {
	      for (var i = start; i < end; i++) {
	        if (this.isCharacterAFormat(i, value)) return true;
	      }
	
	      return false;
	    }
	    /**
	     * This will check if any formatting got removed by the delete or backspace and reset the value
	     * It will also work as fallback if android chome keyDown handler does not work
	     **/
	
	  }, {
	    key: "correctInputValue",
	    value: function correctInputValue(caretPos, lastValue, value) {
	      var _this$props10 = this.props,
	          format = _this$props10.format,
	          decimalSeparator = _this$props10.decimalSeparator,
	          allowNegative = _this$props10.allowNegative,
	          prefix = _this$props10.prefix,
	          suffix = _this$props10.suffix;
	      var lastNumStr = this.state.numAsString || '';
	      var _this$selectionBefore = this.selectionBeforeInput,
	          selectionStart = _this$selectionBefore.selectionStart,
	          selectionEnd = _this$selectionBefore.selectionEnd;
	
	      var _findChangedIndex = (0, _utils.findChangedIndex)(lastValue, value),
	          start = _findChangedIndex.start,
	          end = _findChangedIndex.end;
	      /* don't do anyhting if something got added,
	       or if value is empty string (when whole input is cleared)
	       or whole input is replace with a number
	      */
	
	
	      var leftBound = !!format ? 0 : prefix.length;
	      var rightBound = lastValue.length - (!!format ? 0 : suffix.length);
	
	      if (value.length > lastValue.length || !value.length || start === end || selectionStart === 0 && selectionEnd === lastValue.length || selectionStart === leftBound && selectionEnd === rightBound) {
	        return value;
	      } //if format got deleted reset the value to last value
	
	
	      if (this.checkIfFormatGotDeleted(start, end, lastValue)) {
	        value = lastValue;
	      } //for numbers check if beforeDecimal got deleted and there is nothing after decimal,
	      //clear all numbers in such case while keeping the - sign
	
	
	      if (!format) {
	        var numericString = this.removeFormatting(value);
	
	        var _splitDecimal2 = (0, _utils.splitDecimal)(numericString, allowNegative),
	            beforeDecimal = _splitDecimal2.beforeDecimal,
	            afterDecimal = _splitDecimal2.afterDecimal,
	            addNegation = _splitDecimal2.addNegation; // eslint-disable-line prefer-const
	        //clear only if something got deleted
	
	
	        var isBeforeDecimalPoint = caretPos < value.indexOf(decimalSeparator) + 1;
	
	        if (numericString.length < lastNumStr.length && isBeforeDecimalPoint && beforeDecimal === '' && !parseFloat(afterDecimal)) {
	          return addNegation ? '-' : '';
	        }
	      }
	
	      return value;
	    }
	  }, {
	    key: "onChange",
	    value: function onChange(e) {
	      e.persist();
	      var el = e.target;
	      var inputValue = el.value;
	      var state = this.state,
	          props = this.props;
	      var isAllowed = props.isAllowed;
	      var lastValue = state.value || '';
	      /*Max of selectionStart and selectionEnd is taken for the patch of pixel and other mobile device caret bug*/
	
	      var currentCaretPosition = Math.max(el.selectionStart, el.selectionEnd);
	      inputValue = this.correctInputValue(currentCaretPosition, lastValue, inputValue);
	      var formattedValue = this.formatInput(inputValue) || '';
	      var numAsString = this.removeFormatting(formattedValue);
	      var valueObj = this.getValueObject(formattedValue, numAsString);
	
	      if (!isAllowed(valueObj)) {
	        formattedValue = lastValue;
	      } //set the value imperatively, this is required for IE fix
	
	
	      el.value = formattedValue; //get the caret position
	
	      var caretPos = this.getCaretPosition(inputValue, formattedValue, currentCaretPosition); //set caret position
	
	      this.setPatchedCaretPosition(el, caretPos, formattedValue); //change the state
	
	      if (formattedValue !== lastValue) {
	        this.setState({
	          value: formattedValue,
	          numAsString: numAsString
	        }, function () {
	          props.onValueChange(valueObj, e);
	          props.onChange(e);
	        });
	      } else {
	        props.onChange(e);
	      }
	    }
	  }, {
	    key: "onBlur",
	    value: function onBlur(e) {
	      var _this2 = this;
	
	      var props = this.props,
	          state = this.state;
	      var format = props.format,
	          onBlur = props.onBlur;
	      var numAsString = state.numAsString;
	      var lastValue = state.value;
	
	      if (!format) {
	        numAsString = (0, _utils.fixLeadingZero)(numAsString);
	        var formattedValue = this.formatNumString(numAsString); //change the state
	
	        if (formattedValue !== lastValue) {
	          // the event needs to be persisted because its properties can be accessed in an asynchronous way
	          e.persist();
	          this.setState({
	            value: formattedValue,
	            numAsString: numAsString
	          }, function () {
	            var valueObj = _this2.getValueObject(formattedValue, numAsString);
	
	            props.onValueChange(valueObj, e);
	            onBlur(e);
	          });
	          return;
	        }
	      }
	
	      onBlur(e);
	    }
	  }, {
	    key: "onKeyDown",
	    value: function onKeyDown(e) {
	      var _this3 = this;
	
	      var el = e.target;
	      var key = e.key;
	      var selectionStart = el.selectionStart,
	          selectionEnd = el.selectionEnd,
	          _el$value = el.value,
	          value = _el$value === void 0 ? '' : _el$value;
	      var expectedCaretPosition;
	      var _this$props11 = this.props,
	          decimalScale = _this$props11.decimalScale,
	          fixedDecimalScale = _this$props11.fixedDecimalScale,
	          prefix = _this$props11.prefix,
	          suffix = _this$props11.suffix,
	          format = _this$props11.format,
	          onKeyDown = _this$props11.onKeyDown,
	          onValueChange = _this$props11.onValueChange;
	      var ignoreDecimalSeparator = decimalScale !== undefined && fixedDecimalScale;
	      var numRegex = this.getNumberRegex(false, ignoreDecimalSeparator);
	      var negativeRegex = new RegExp('-');
	      var isPatternFormat = typeof format === 'string';
	      this.selectionBeforeInput = {
	        selectionStart: selectionStart,
	        selectionEnd: selectionEnd //Handle backspace and delete against non numerical/decimal characters or arrow keys
	
	      };
	
	      if (key === 'ArrowLeft' || key === 'Backspace') {
	        expectedCaretPosition = selectionStart - 1;
	      } else if (key === 'ArrowRight') {
	        expectedCaretPosition = selectionStart + 1;
	      } else if (key === 'Delete') {
	        expectedCaretPosition = selectionStart;
	      } //if expectedCaretPosition is not set it means we don't want to Handle keyDown
	      //also if multiple characters are selected don't handle
	
	
	      if (expectedCaretPosition === undefined || selectionStart !== selectionEnd) {
	        onKeyDown(e);
	        return;
	      }
	
	      var newCaretPosition = expectedCaretPosition;
	      var leftBound = isPatternFormat ? format.indexOf('#') : prefix.length;
	      var rightBound = isPatternFormat ? format.lastIndexOf('#') + 1 : value.length - suffix.length;
	
	      if (key === 'ArrowLeft' || key === 'ArrowRight') {
	        var direction = key === 'ArrowLeft' ? 'left' : 'right';
	        newCaretPosition = this.correctCaretPosition(value, expectedCaretPosition, direction);
	      } else if (key === 'Delete' && !numRegex.test(value[expectedCaretPosition]) && !negativeRegex.test(value[expectedCaretPosition])) {
	        while (!numRegex.test(value[newCaretPosition]) && newCaretPosition < rightBound) {
	          newCaretPosition++;
	        }
	      } else if (key === 'Backspace' && !numRegex.test(value[expectedCaretPosition])) {
	        /* NOTE: This is special case when backspace is pressed on a
	        negative value while the cursor position is after prefix. We can't handle it on onChange because
	        we will not have any information of keyPress
	        */
	        if (selectionStart <= leftBound + 1 && value[0] === '-' && typeof format === 'undefined') {
	          var newValue = value.substring(1);
	          var numAsString = this.removeFormatting(newValue);
	          var valueObj = this.getValueObject(newValue, numAsString); //persist event before performing async task
	
	          e.persist();
	          this.setState({
	            value: newValue,
	            numAsString: numAsString
	          }, function () {
	            _this3.setPatchedCaretPosition(el, newCaretPosition, newValue);
	
	            onValueChange(valueObj, e);
	          });
	        } else if (!negativeRegex.test(value[expectedCaretPosition])) {
	          while (!numRegex.test(value[newCaretPosition - 1]) && newCaretPosition > leftBound) {
	            newCaretPosition--;
	          }
	
	          newCaretPosition = this.correctCaretPosition(value, newCaretPosition, 'left');
	        }
	      }
	
	      if (newCaretPosition !== expectedCaretPosition || expectedCaretPosition < leftBound || expectedCaretPosition > rightBound) {
	        e.preventDefault();
	        this.setPatchedCaretPosition(el, newCaretPosition, value);
	      }
	      /* NOTE: this is just required for unit test as we need to get the newCaretPosition,
	              Remove this when you find different solution */
	
	
	      if (e.isUnitTestRun) {
	        this.setPatchedCaretPosition(el, newCaretPosition, value);
	      }
	
	      this.props.onKeyDown(e);
	    }
	    /** required to handle the caret position when click anywhere within the input **/
	
	  }, {
	    key: "onMouseUp",
	    value: function onMouseUp(e) {
	      var el = e.target;
	      /**
	       * NOTE: we have to give default value for value as in case when custom input is provided
	       * value can come as undefined when nothing is provided on value prop.
	      */
	
	      var selectionStart = el.selectionStart,
	          selectionEnd = el.selectionEnd,
	          _el$value2 = el.value,
	          value = _el$value2 === void 0 ? '' : _el$value2;
	
	      if (selectionStart === selectionEnd) {
	        var caretPosition = this.correctCaretPosition(value, selectionStart);
	
	        if (caretPosition !== selectionStart) {
	          this.setPatchedCaretPosition(el, caretPosition, value);
	        }
	      }
	
	      this.props.onMouseUp(e);
	    }
	  }, {
	    key: "onFocus",
	    value: function onFocus(e) {
	      var _this4 = this;
	
	      // Workaround Chrome and Safari bug https://bugs.chromium.org/p/chromium/issues/detail?id=779328
	      // (onFocus event target selectionStart is always 0 before setTimeout)
	      e.persist();
	      setTimeout(function () {
	        var el = e.target;
	        var selectionStart = el.selectionStart,
	            selectionEnd = el.selectionEnd,
	            _el$value3 = el.value,
	            value = _el$value3 === void 0 ? '' : _el$value3;
	
	        var caretPosition = _this4.correctCaretPosition(value, selectionStart); //setPatchedCaretPosition only when everything is not selected on focus (while tabbing into the field)
	
	
	        if (caretPosition !== selectionStart && !(selectionStart === 0 && selectionEnd === value.length)) {
	          _this4.setPatchedCaretPosition(el, caretPosition, value);
	        }
	
	        _this4.props.onFocus(e);
	      }, 0);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props12 = this.props,
	          type = _this$props12.type,
	          displayType = _this$props12.displayType,
	          customInput = _this$props12.customInput,
	          renderText = _this$props12.renderText,
	          getInputRef = _this$props12.getInputRef;
	      var value = this.state.value;
	      var otherProps = (0, _utils.omit)(this.props, propTypes);
	      var inputProps = Object.assign({}, otherProps, {
	        type: type,
	        value: value,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onMouseUp: this.onMouseUp,
	        onFocus: this.onFocus,
	        onBlur: this.onBlur
	      });
	
	      if (displayType === 'text') {
	        return renderText ? renderText(value) || null : _react.default.createElement("span", _extends({}, otherProps, {
	          ref: getInputRef
	        }), value);
	      } else if (customInput) {
	        var CustomInput = customInput;
	        return _react.default.createElement(CustomInput, inputProps);
	      }
	
	      return _react.default.createElement("input", _extends({}, inputProps, {
	        ref: getInputRef
	      }));
	    }
	  }]);
	
	  return NumberFormat;
	}(_react.default.Component);
	
	NumberFormat.propTypes = propTypes;
	NumberFormat.defaultProps = defaultProps;
	var _default = NumberFormat;
	exports.default = _default;
	module.exports = exports.default;

/***/ }),

/***/ 509:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noop = noop;
	exports.returnTrue = returnTrue;
	exports.charIsNumber = charIsNumber;
	exports.escapeRegExp = escapeRegExp;
	exports.splitDecimal = splitDecimal;
	exports.fixLeadingZero = fixLeadingZero;
	exports.limitToScale = limitToScale;
	exports.roundToPrecision = roundToPrecision;
	exports.omit = omit;
	exports.setCaretPosition = setCaretPosition;
	exports.findChangedIndex = findChangedIndex;
	exports.clamp = clamp;
	
	// basic noop function
	function noop() {}
	
	function returnTrue() {
	  return true;
	}
	
	function charIsNumber(char) {
	  return !!(char || '').match(/\d/);
	}
	
	function escapeRegExp(str) {
	  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
	} //spilt a float number into different parts beforeDecimal, afterDecimal, and negation
	
	
	function splitDecimal(numStr) {
	  var allowNegative = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var hasNagation = numStr[0] === '-';
	  var addNegation = hasNagation && allowNegative;
	  numStr = numStr.replace('-', '');
	  var parts = numStr.split('.');
	  var beforeDecimal = parts[0];
	  var afterDecimal = parts[1] || '';
	  return {
	    beforeDecimal: beforeDecimal,
	    afterDecimal: afterDecimal,
	    hasNagation: hasNagation,
	    addNegation: addNegation
	  };
	}
	
	function fixLeadingZero(numStr) {
	  if (!numStr) return numStr;
	  var isNegative = numStr[0] === '-';
	  if (isNegative) numStr = numStr.substring(1, numStr.length);
	  var parts = numStr.split('.');
	  var beforeDecimal = parts[0].replace(/^0+/, '') || '0';
	  var afterDecimal = parts[1] || '';
	  return "".concat(isNegative ? '-' : '').concat(beforeDecimal).concat(afterDecimal ? ".".concat(afterDecimal) : '');
	}
	/**
	 * limit decimal numbers to given scale
	 * Not used .fixedTo because that will break with big numbers
	 */
	
	
	function limitToScale(numStr, scale, fixedDecimalScale) {
	  var str = '';
	  var filler = fixedDecimalScale ? '0' : '';
	
	  for (var i = 0; i <= scale - 1; i++) {
	    str += numStr[i] || filler;
	  }
	
	  return str;
	}
	/**
	 * This method is required to round prop value to given scale.
	 * Not used .round or .fixedTo because that will break with big numbers
	 */
	
	
	function roundToPrecision(numStr, scale, fixedDecimalScale) {
	  //if number is empty don't do anything return empty string
	  if (['', '-'].indexOf(numStr) !== -1) return numStr;
	  var shoudHaveDecimalSeparator = numStr.indexOf('.') !== -1 && scale;
	
	  var _splitDecimal = splitDecimal(numStr),
	      beforeDecimal = _splitDecimal.beforeDecimal,
	      afterDecimal = _splitDecimal.afterDecimal,
	      hasNagation = _splitDecimal.hasNagation;
	
	  var roundedDecimalParts = parseFloat("0.".concat(afterDecimal || '0')).toFixed(scale).split('.');
	  var intPart = beforeDecimal.split('').reverse().reduce(function (roundedStr, current, idx) {
	    if (roundedStr.length > idx) {
	      return (Number(roundedStr[0]) + Number(current)).toString() + roundedStr.substring(1, roundedStr.length);
	    }
	
	    return current + roundedStr;
	  }, roundedDecimalParts[0]);
	  var decimalPart = limitToScale(roundedDecimalParts[1] || '', Math.min(scale, afterDecimal.length), fixedDecimalScale);
	  var negation = hasNagation ? '-' : '';
	  var decimalSeparator = shoudHaveDecimalSeparator ? '.' : '';
	  return "".concat(negation).concat(intPart).concat(decimalSeparator).concat(decimalPart);
	}
	
	function omit(obj, keyMaps) {
	  var filteredObj = {};
	  Object.keys(obj).forEach(function (key) {
	    if (!keyMaps[key]) filteredObj[key] = obj[key];
	  });
	  return filteredObj;
	}
	/** set the caret positon in an input field **/
	
	
	function setCaretPosition(el, caretPos) {
	  el.value = el.value; // ^ this is used to not only get "focus", but
	  // to make sure we don't have it everything -selected-
	  // (it causes an issue in chrome, and having it doesn't hurt any other browser)
	
	  if (el !== null) {
	    if (el.createTextRange) {
	      var range = el.createTextRange();
	      range.move('character', caretPos);
	      range.select();
	      return true;
	    } // (el.selectionStart === 0 added for Firefox bug)
	
	
	    if (el.selectionStart || el.selectionStart === 0) {
	      el.focus();
	      el.setSelectionRange(caretPos, caretPos);
	      return true;
	    } // fail city, fortunately this never happens (as far as I've tested) :)
	
	
	    el.focus();
	    return false;
	  }
	}
	/**
	  Given previous value and newValue it returns the index
	  start - end to which values have changed.
	  This function makes assumption about only consecutive
	  characters are changed which is correct assumption for caret input.
	*/
	
	
	function findChangedIndex(prevValue, newValue) {
	  var i = 0,
	      j = 0;
	  var prevLength = prevValue.length;
	  var newLength = newValue.length;
	
	  while (prevValue[i] === newValue[i] && i < prevLength) {
	    i++;
	  } //check what has been changed from last
	
	
	  while (prevValue[prevLength - 1 - j] === newValue[newLength - 1 - j] && newLength - j > i && prevLength - j > i) {
	    j++;
	  }
	
	  return {
	    start: i,
	    end: prevLength - j
	  };
	}
	/*
	  Returns a number whose value is limited to the given range
	*/
	
	
	function clamp(num, min, max) {
	  return Math.min(Math.max(num, min), max);
	}

/***/ }),

/***/ 104:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(36);
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),

/***/ 34:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(138);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(111);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(34);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(112);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(106);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(107);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(108);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(109);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(21);
	
	var _wrapMapToProps = __webpack_require__(35);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(35);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),

/***/ 108:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(37);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),

/***/ 109:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(110);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),

/***/ 110:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),

/***/ 35:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(37);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(104);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(34);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(105);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),

/***/ 36:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),

/***/ 111:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),

/***/ 112:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(15);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),

/***/ 17:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(38);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),

/***/ 116:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(39);
	
	var _isPlainObject = __webpack_require__(15);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(40);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(15);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(118);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(39);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(117);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(116);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(115);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(38);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(40);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(119);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(121)(module)))

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(176);
	
	var _nl = __webpack_require__(179);
	
	var _nl2 = _interopRequireDefault(_nl);
	
	var _reactFlatpickr = __webpack_require__(198);
	
	var _reactFlatpickr2 = _interopRequireDefault(_reactFlatpickr);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(21);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _simplyBookService = __webpack_require__(30);
	
	var SimplyBookService = _interopRequireWildcard(_simplyBookService);
	
	var _simplyBook = __webpack_require__(124);
	
	var SimplybookActions = _interopRequireWildcard(_simplyBook);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var AvailabilityWidget = function (_Component) {
	    _inherits(AvailabilityWidget, _Component);
	
	    function AvailabilityWidget(props) {
	        _classCallCheck(this, AvailabilityWidget);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.state = {
	            eventDate: '',
	            eventType: '',
	            notAvailable: false
	        };
	        return _this;
	    }
	
	    AvailabilityWidget.prototype.componentWillMount = function componentWillMount() {
	        if (!this.props.simplyBook.initiated) {
	            this.props.simplybookActions.getEvents();
	        }
	
	        if (this.props.reservation && this.props.simplyBook.newEvent && this.props.simplyBook.newEvent.event) {
	            this.prefillComponent();
	        }
	    };
	
	    AvailabilityWidget.prototype.prefillComponent = function prefillComponent() {
	        this.setState({
	            eventDate: this.props.simplyBook.newEvent.event.eventDate,
	            eventType: this.props.simplyBook.newEvent.event.eventId,
	            hideButton: true,
	            checkingAvailability: false
	        });
	    };
	
	    AvailabilityWidget.prototype.checkAvailability = function checkAvailability(event) {
	        var _this2 = this;
	
	        event.preventDefault();
	
	        // Reset state
	        this.setState({
	            checkingAvailability: true,
	            notAvailable: false
	        });
	
	        var newEvent = {
	            eventId: this.state.eventType,
	            eventDate: this.state.eventDate
	        };
	
	        SimplyBookService.checkAvailability(newEvent).then(function (response) {
	            if (response.data.result.length === 0) {
	                _this2.setState({
	                    checkingAvailability: false,
	                    notAvailable: true
	                });
	            } else {
	                _this2.props.simplybookActions.prepareBooking(response.data.result, newEvent);
	
	                // Update state or navigate to reservation page
	                if (_this2.props.reservation) {
	                    _this2.prefillComponent();
	                } else {
	                    (0, _gatsbyLink.navigateTo)('/reserveren');
	                }
	            }
	        }).catch(function (error) {
	            _this2.setState({
	                checkingAvailability: false,
	                notAvailable: true
	            });
	        });
	    };
	
	    AvailabilityWidget.prototype.renderEventOptions = function renderEventOptions() {
	        var events = this.props.simplyBook.events;
	
	        return Object.keys(events).map(function (key) {
	            return _react2.default.createElement(
	                'option',
	                { key: key, value: events[key].id },
	                events[key].name
	            );
	        });
	    };
	
	    AvailabilityWidget.prototype.handleDatePicker = function handleDatePicker(value) {
	        if (value.length) {
	            this.props.simplybookActions.resetEvent();
	            this.setState({
	                eventDate: value[0],
	                hideButton: false
	            });
	        }
	    };
	
	    AvailabilityWidget.prototype.handleSelect = function handleSelect(event) {
	        this.props.simplybookActions.resetEvent();
	        this.setState({
	            eventType: event.target.value,
	            hideButton: false
	        });
	    };
	
	    AvailabilityWidget.prototype.render = function render() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            'form',
	            { className: 'availabilityWidget has-padding-bottom', onSubmit: function onSubmit(event) {
	                    return _this3.checkAvailability(event);
	                } },
	            _react2.default.createElement(
	                'div',
	                { className: 'columns' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'column' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'select is-fullwidth is-medium' },
	                        _react2.default.createElement(
	                            'select',
	                            { name: 'eventType', value: this.state.eventType, onChange: this.handleSelect.bind(this), required: true },
	                            _react2.default.createElement(
	                                'option',
	                                { value: '' },
	                                'Selecteer een photobooth'
	                            ),
	                            this.renderEventOptions()
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'column' },
	                    _react2.default.createElement(_reactFlatpickr2.default, {
	                        required: 'required',
	                        options: {
	                            locale: _nl2.default['nl'],
	                            altInput: true,
	                            minDate: new Date().fp_incr(1),
	                            maxDate: new Date().fp_incr(365)
	                        },
	                        name: 'eventDate',
	                        value: this.state.eventDate,
	                        placeholder: 'Datum van evenement', className: 'input is-medium is-fullwidth', onChange: function onChange(data) {
	                            return _this3.handleDatePicker(data);
	                        } })
	                ),
	                !this.state.hideButton && _react2.default.createElement(
	                    'div',
	                    { className: 'column' },
	                    _react2.default.createElement(
	                        'button',
	                        {
	                            disabled: this.state.eventDate && this.state.eventType ? undefined : 'disabled',
	                            className: 'button is-primary is-medium is-fullwidth ' + (this.state.checkingAvailability ? 'is-loading' : '') },
	                        'Check!'
	                    )
	                )
	            ),
	            this.state.notAvailable && _react2.default.createElement(
	                'div',
	                { className: 'notification is-danger' },
	                'Helaas, de photobooth die jij wilt boeken is op de geselecteerde datum niet beschikbaar. Kies een andere photobooth of bel met ',
	                _react2.default.createElement(
	                    'a',
	                    { href: 'tel:0644066185' },
	                    '+31 (0)6 - 440 661 85'
	                ),
	                ' om te achterhalen wat de overige mogelijkheden zijn.'
	            )
	        );
	    };
	
	    return AvailabilityWidget;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        simplyBook: state.simplyBook
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        simplybookActions: (0, _redux.bindActionCreators)(SimplybookActions, dispatch)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(AvailabilityWidget);
	module.exports = exports['default'];

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ChristmasNotification = function ChristmasNotification() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	            'div',
	            { className: 'container' },
	            _react2.default.createElement(
	                'div',
	                { className: 'notification is-danger christmas-notification' },
	                _react2.default.createElement(
	                    'h2',
	                    { className: 'title' },
	                    _react2.default.createElement('i', { className: 'icon-christmas-tree' }),
	                    ' Kerstactie! ',
	                    _react2.default.createElement('i', { className: 'icon-christmas-tree' })
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Reserveer voor 10 december een photobooth tussen ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        '15 december - 27 december'
	                    ),
	                    ' en ontvang gratis ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'premium kerst props'
	                    ),
	                    ' (t.w.v. \u20AC25,-), een ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'op maat gemaakt frame'
	                    ),
	                    ' (t.w.v. \u20AC25,-) en alle foto\'s op ',
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'luxe usb'
	                    ),
	                    ' geleverd (t.w.v. \u20AC25,-).'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: 'button is-primary is-hidden-mobile', to: 'reserveren' },
	                    ' Reserveer direct een photobooth voor de kerst'
	                ),
	                _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { className: 'button is-primary is-hidden-tablet', to: 'reserveren' },
	                    ' Reserveer direct!'
	                )
	            )
	        )
	    );
	};
	
	exports.default = ChristmasNotification;
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _priceDisplay = __webpack_require__(123);
	
	var _priceDisplay2 = _interopRequireDefault(_priceDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CheckBoxGroup = function CheckBoxGroup(_ref) {
	    var _onChange = _ref.onChange,
	        items = _ref.items,
	        name = _ref.name;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'option-list columns is-multiline is-mobile' },
	        items.map(function (item, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: name + '-' + index, className: 'column is-half-mobile     is-one-quarter-tablet' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'card card-option' },
	                    _react2.default.createElement('input', { type: 'checkbox', value: '', name: item.title, onChange: function onChange(e) {
	                            return _onChange(e, item);
	                        } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-content has-text-centered' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-option__image' },
	                            _react2.default.createElement('img', { src: 'https://placehold.it/150', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            item.title
	                        ),
	                        item.description && _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                item.description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'price-tag' },
	                            _react2.default.createElement(_priceDisplay2.default, { price: item.price })
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = CheckBoxGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(60);
	
	var _redux = __webpack_require__(21);
	
	var _availabilityWidget = __webpack_require__(147);
	
	var _availabilityWidget2 = _interopRequireDefault(_availabilityWidget);
	
	var _sidebar = __webpack_require__(289);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	var _radioGroup = __webpack_require__(288);
	
	var _radioGroup2 = _interopRequireDefault(_radioGroup);
	
	var _checkboxGroup = __webpack_require__(286);
	
	var _checkboxGroup2 = _interopRequireDefault(_checkboxGroup);
	
	var _summary = __webpack_require__(290);
	
	var _summary2 = _interopRequireDefault(_summary);
	
	var _simplyBookService = __webpack_require__(30);
	
	var SimplyBookService = _interopRequireWildcard(_simplyBookService);
	
	var _simplyBook = __webpack_require__(124);
	
	var SimplybookActions = _interopRequireWildcard(_simplyBook);
	
	var _options = __webpack_require__(293);
	
	var PriceConfig = _interopRequireWildcard(_options);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReservationForm = function (_Component) {
	    _inherits(ReservationForm, _Component);
	
	    function ReservationForm(props) {
	        _classCallCheck(this, ReservationForm);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	        _this.chosenOptions = {};
	
	        _this.state = {
	            currentStep: 2,
	            basePrice: 0,
	            selectedOptions: [],
	            boothInfo: {},
	            optionProps: null,
	            userAddress: null,
	            contactInfo: {}
	        };
	        return _this;
	    }
	
	    ReservationForm.prototype.componentWillMount = function componentWillMount() {
	        this.setSideBar(this.props);
	    };
	
	    ReservationForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.setSideBar(nextProps);
	    };
	
	    /**
	     * This method will set the necessary information for the sidebar
	     */
	
	
	    ReservationForm.prototype.setSideBar = function setSideBar(props) {
	        if (props.simplyBook.newEvent && props.simplyBook.newEvent.event && props.simplyBook.newEvent.event.eventId) {
	            this.setState({
	                boothInfo: props.simplyBook.events[props.simplyBook.newEvent.event.eventId],
	                basePrice: PriceConfig.boothPricing[props.simplyBook.newEvent.event.eventId]
	            });
	        }
	    };
	
	    /**
	     * This method will handle all the radio button options
	     * @param item
	     * @param groupName
	     */
	
	
	    ReservationForm.prototype.handleRadioGroup = function handleRadioGroup(item, groupName) {
	        if (!this.chosenOptions[groupName]) {
	            this.chosenOptions[groupName] = item;
	            this.setState({
	                selectedOptions: [].concat(this.state.selectedOptions, item)
	            });
	        } else {
	            var previousOption = this.chosenOptions[groupName];
	            var clearedList = this.state.selectedOptions.filter(function (obj) {
	                return obj.title !== previousOption.title;
	            });
	            this.setState({
	                selectedOptions: [].concat(clearedList, item)
	            });
	            // Set new group name option
	            this.chosenOptions[groupName] = item;
	        }
	    };
	
	    ReservationForm.prototype.handleCheckBoxGroup = function handleCheckBoxGroup(checkbox, item) {
	        if (checkbox.target.checked) {
	            this.setState({
	                selectedOptions: [].concat(this.state.selectedOptions, [item])
	            });
	        } else {
	            var clearedList = this.state.selectedOptions.filter(function (obj) {
	                return obj.title !== item.title;
	            });
	            this.setState({
	                selectedOptions: clearedList
	            });
	        }
	    };
	
	    ReservationForm.prototype.submitRequest = function submitRequest(event) {
	        var _this2 = this;
	
	        event.preventDefault();
	
	        var totalPrice = this.state.selectedOptions.reduce(function (total, item) {
	            return total + item.price;
	        }, this.state.basePrice);
	
	        var optionList = this.state.selectedOptions.map(function (item) {
	            return item.title;
	        }).join(", ");
	
	        var reservation = {
	            "eventId": this.props.simplyBook.newEvent.event.eventId,
	            // Select the first unit from the availability list
	            "unitId": this.props.simplyBook.newEvent.availability[0],
	            "date": this.props.simplyBook.newEvent.event.eventDate,
	            "time": "12:00",
	            "boothName": this.state.boothInfo.name,
	            "customerName": this.refs.firstName.value + ' ' + this.refs.lastName.value,
	            "customerEmail": this.refs.emailAdress.value,
	            "customerPhone": this.refs.phoneNumber.value,
	            "customerAddress": this.refs.streetName.value + ' ' + this.refs.houseNumber.value,
	            "customerCity": this.refs.city.value,
	            "customerZip": this.refs.postalCode.value,
	            "companyName": this.refs.companyName.value,
	            "eventCity": this.refs.eventCity.value,
	            "eventLocation": this.refs.eventLocation.value,
	            "eventPostalCode": this.refs.eventPostalCode.value,
	            "eventStreet": this.refs.eventStreet.value + ' ' + this.refs.eventHouseNumber.value,
	            "eventType": this.refs.eventType.value,
	            "message": this.refs.message.value,
	            "options": optionList,
	            "pricing": totalPrice
	        };
	
	        this.setState({
	            makingReservation: true
	        });
	
	        SimplyBookService.makeBooking(reservation).then(function () {
	            _this2.setState({
	                makingReservation: false,
	                finishedBooking: true
	            });
	        }).catch(function () {
	            _this2.setState({
	                makingReservation: false
	            });
	        });
	    };
	
	    ReservationForm.prototype.renderOptionsBlock = function renderOptionsBlock() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'columns is-multiline' },
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-full' },
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'step--active' },
	                    'Stap 2: Selecteer de gewenste opties'
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-full' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    _react2.default.createElement(
	                        'strong',
	                        null,
	                        'Selecteer een props pakket'
	                    ),
	                    _react2.default.createElement('br', null),
	                    'Snorretjes, duimpje omhoog en brilletjes. Een kleine greep uit het assortiment aan photo props. Standaard krijg je van ons een setje met standaard props die het goed doen op elk feestje. Wil je props voor een baby shower, kerst of oud en nieuw? Kies dan voor thema props.'
	                ),
	                _react2.default.createElement(_radioGroup2.default, { name: 'props', onChange: this.handleRadioGroup.bind(this), items: PriceConfig.orderOptions.props })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-full' },
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Kies uit een frame'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_radioGroup2.default, { name: 'template', onChange: this.handleRadioGroup.bind(this), items: PriceConfig.orderOptions.templates })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-full' },
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Kies een achtergrond'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_radioGroup2.default, { name: 'backdrops', onChange: this.handleRadioGroup.bind(this), items: PriceConfig.orderOptions.backDrops })
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column is-full' },
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Maak de booth compleet'
	                ),
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_checkboxGroup2.default, { onChange: this.handleCheckBoxGroup.bind(this), items: PriceConfig.orderOptions.expansion })
	            )
	        );
	    };
	
	    ReservationForm.prototype.renderContact = function renderContact() {
	        var _this3 = this;
	
	        return _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'Contactgegevens'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Voornaam'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input', type: 'text', placeholder: '', ref: 'firstName', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Achternaam'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input ', type: 'text', ref: 'lastName', required: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'lable',
	                                { className: 'label' },
	                                'Bedrijsnaam'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement('input', { type: 'text', className: 'input', placeholder: 'Indien van toepassing', ref: 'companyName' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Straatnaam'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input', type: 'text', placeholder: '', ref: 'streetName', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Huisnummer'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input ', type: 'number', ref: 'houseNumber', required: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Postcode'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input', type: 'text', ref: 'postalCode', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Woonplaats'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input ', type: 'text', ref: 'city', required: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'lable',
	                                { className: 'label' },
	                                'E-mail adres'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement('input', { type: 'email', className: 'input', ref: 'emailAdress', onChange: function onChange(evt) {
	                                        _this3.setState({ userAddress: evt.target.value });
	                                    }, required: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'lable',
	                                { className: 'label' },
	                                'Telefoonnummer'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement('input', { type: 'text', className: 'input', ref: 'phoneNumber', required: true })
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'card' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'content' },
	                            _react2.default.createElement(
	                                'h5',
	                                null,
	                                'Feestlocatie'
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'label' },
	                                'Soort feest / evenement'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'select' },
	                                    _react2.default.createElement(
	                                        'select',
	                                        { id: 'dropdown', ref: 'eventType' },
	                                        _react2.default.createElement(
	                                            'option',
	                                            { value: '' },
	                                            'Selecteer een soort'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Bruiloft'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Verjaardag / Jubileumfeest'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Beurs'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Personeelsfeest'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Evenement'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Open dag'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Anders'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'lable',
	                                { className: 'label' },
	                                'Locatie'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement('input', { type: 'text', className: 'input', placeholder: 'Bijvoorbeeld Partyboerderij Hijdra', ref: 'eventLocation', required: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Straatnaam'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input', type: 'text', ref: 'eventStreet', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Huisnummer'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input ', type: 'number', ref: 'eventHouseNumber', required: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'field-body' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Postcode'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input', type: 'text', ref: 'eventPostalCode', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'field' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        { className: 'label' },
	                                        'Plaats'
	                                    ),
	                                    _react2.default.createElement(
	                                        'p',
	                                        { className: 'control' },
	                                        _react2.default.createElement('input', { className: 'input ', type: 'text', ref: 'eventCity', required: true })
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'label' },
	                                'Opmerkingen'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement('textarea', { className: 'textarea is-primary', type: 'text', ref: 'message', placeholder: 'Gebruik dit veld om bijzondere informatie te vermelden zoals locatie heeft alleen een trap, speciale wensen of bijvoorbeeld dat het een buiten locatie betreft' })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'field' },
	                            _react2.default.createElement(
	                                'label',
	                                { className: 'label' },
	                                'Hoe heb je ons gevonden'
	                            ),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'control' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: 'select' },
	                                    _react2.default.createElement(
	                                        'select',
	                                        { name: 'referral', id: 'referral' },
	                                        _react2.default.createElement(
	                                            'option',
	                                            { value: '' },
	                                            'Kies een van de opties..'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Facebook'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Google'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Via vrienden of familie'
	                                        ),
	                                        _react2.default.createElement(
	                                            'option',
	                                            null,
	                                            'Anders'
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    ReservationForm.prototype.renderForm = function renderForm() {
	        return _react2.default.createElement(
	            'div',
	            { className: 'columns is-multiline' },
	            _react2.default.createElement(
	                'div',
	                { className: 'column' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'form',
	                        { onSubmit: this.submitRequest.bind(this) },
	                        this.props.simplyBook.newEvent && this.props.simplyBook.newEvent.availability && this.props.simplyBook.newEvent.availability.length > 0 && _react2.default.createElement(
	                            'div',
	                            { className: 'notification is-primary' },
	                            'Goed nieuws! We hebben nog een Photobooth voor je beschikbaar!'
	                        ),
	                        this.renderOptionsBlock(),
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'step--active' },
	                            'Stap 3: Voer de contactgegevens en feestlocatie in'
	                        ),
	                        this.renderContact(),
	                        _react2.default.createElement(_summary2.default, {
	                            boothInfo: this.state.boothInfo,
	                            event: this.props.simplyBook.newEvent.event,
	                            selectedOptions: this.state.selectedOptions,
	                            userAddress: this.state.userAddress,
	                            basePrice: this.state.basePrice
	                        }),
	                        _react2.default.createElement(
	                            'button',
	                            { type: 'submit', className: 'button is-primary  ' + (this.state.makingReservation ? 'is-loading' : '') },
	                            'Plaats een reservering'
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(_sidebar2.default, {
	                boothInfo: this.state.boothInfo,
	                prices: {
	                    basePrice: this.state.basePrice,
	                    selectedOptions: this.state.selectedOptions
	                }
	            })
	        );
	    };
	
	    ReservationForm.prototype.render = function render() {
	        if (this.state.finishedBooking) {
	            return _react2.default.createElement(
	                'div',
	                { className: 'section' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'h4',
	                            { className: 'step--active' },
	                            'Bedankt voor uw boeking!'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'U ontvangt binnen 24 uur een reserveringsbevestiging van ons. Mocht u aangegeven hebben dat u op maat gemaakte props, frames of achtergronden wenst dan zal onze ontwerper eveneens binnen 24 uur contact met u opnemen.'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'Heeft u in de tussentijd vragen of opmerkingen dan kunt u maandag tot en met zaterdag van 09:00 uur tot 21:00 uur contact met ons opnemen via telefoon of whatsapp: ',
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                _react2.default.createElement(
	                                    'a',
	                                    { href: 'https://api.whatsapp.com/send?phone=31644066185' },
	                                    '+31 (0)6 - 440 661 85'
	                                )
	                            )
	                        )
	                    )
	                )
	            );
	        }
	        return _react2.default.createElement(
	            'div',
	            { className: 'section' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'h4',
	                        { className: 'step--active' },
	                        'Stap 1: Maak een keuze voor de photobooth en datum'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We bieden momenteel twee photobooths aan. De Gifture Classic wordt standaard verhuurd zonder begeleiding maar is wel met begeleiding te boeken. De Gifture Event Booth wordt standaard verhuur met een enthousiaste medewerker!'
	                    )
	                ),
	                _react2.default.createElement(_availabilityWidget2.default, { reservation: true }),
	                this.props.simplyBook.newEvent && this.props.simplyBook.newEvent.event && this.renderForm()
	            )
	        );
	    };
	
	    return ReservationForm;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	    return {
	        simplyBook: state.simplyBook
	    };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	    return {
	        simplybookActions: (0, _redux.bindActionCreators)(SimplybookActions, dispatch)
	    };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ReservationForm);
	module.exports = exports['default'];

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactNumberFormat = __webpack_require__(508);
	
	var _reactNumberFormat2 = _interopRequireDefault(_reactNumberFormat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var priceDisplay = function priceDisplay(_ref) {
	    var price = _ref.price,
	        hideAlternative = _ref.hideAlternative;
	
	
	    if (price === 0 && !hideAlternative) {
	        return _react2.default.createElement(
	            'span',
	            null,
	            'Inbegrepen'
	        );
	    } else {
	        return _react2.default.createElement(_reactNumberFormat2.default, {
	            thousandSeparator: '.',
	            fixedDecimalScale: true,
	            decimalSeparator: ',',
	            decimalScale: 2,
	            value: price,
	            displayType: 'text',
	            prefix: '€'
	        });
	    }
	};
	
	exports.default = priceDisplay;
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _priceDisplay = __webpack_require__(123);
	
	var _priceDisplay2 = _interopRequireDefault(_priceDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioGroup = function RadioGroup(_ref) {
	    var _onChange = _ref.onChange,
	        items = _ref.items,
	        name = _ref.name;
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'option-list columns is-multiline is-mobile' },
	        items.map(function (item, index) {
	            return _react2.default.createElement(
	                'div',
	                { key: name + '-' + index, className: 'column is-half-mobile     is-one-quarter-tablet' },
	                _react2.default.createElement(
	                    'label',
	                    { className: 'card card-option' },
	                    _react2.default.createElement('input', { type: 'radio', defaultChecked: item.selected || false, value: item.title, name: name, onChange: function onChange() {
	                            return _onChange(item, name);
	                        } }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'card-content has-text-centered' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'card-option__image' },
	                            _react2.default.createElement('img', { src: 'https://placehold.it/150', alt: '' })
	                        ),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            item.title
	                        ),
	                        item.description && _react2.default.createElement(
	                            'span',
	                            null,
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'small',
	                                null,
	                                item.description
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'price-tag' },
	                            _react2.default.createElement(_priceDisplay2.default, { price: item.price })
	                        )
	                    )
	                )
	            );
	        })
	    );
	};
	
	exports.default = RadioGroup;
	module.exports = exports['default'];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _priceDisplay = __webpack_require__(123);
	
	var _priceDisplay2 = _interopRequireDefault(_priceDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Options = function Options(_ref) {
	    var list = _ref.list;
	
	    return _react2.default.createElement(
	        'ul',
	        { className: 'options-list' },
	        list.map(function (item) {
	            return _react2.default.createElement(
	                'li',
	                null,
	                item.title
	            );
	        })
	    );
	};
	
	var SideBar = function SideBar(_ref2) {
	    var boothInfo = _ref2.boothInfo,
	        prices = _ref2.prices;
	
	
	    var optionsPrice = prices.selectedOptions.reduce(function (total, current) {
	        return total + current.price;
	    }, 0);
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'column is-one-quarter-tablet' },
	        _react2.default.createElement(
	            'div',
	            { className: 'hero is-primary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body has-text-white has-text-centered content' },
	                _react2.default.createElement(
	                    'h4',
	                    { className: 'has-text-white' },
	                    'Samenvatting reservering'
	                ),
	                _react2.default.createElement(
	                    'table',
	                    { className: 'is-fullwidth price-table' },
	                    _react2.default.createElement(
	                        'tbody',
	                        null,
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Basisprijs'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(_priceDisplay2.default, { price: prices.basePrice })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Opties',
	                                prices.selectedOptions.length > 0 && _react2.default.createElement(Options, { list: prices.selectedOptions })
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(_priceDisplay2.default, { price: optionsPrice, hideAlternative: true })
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'tr',
	                            null,
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                'Totaalprijs'
	                            ),
	                            _react2.default.createElement(
	                                'td',
	                                null,
	                                _react2.default.createElement(_priceDisplay2.default, { price: prices.basePrice + optionsPrice })
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'p',
	                    { className: 'has-text-centered' },
	                    _react2.default.createElement(
	                        'small',
	                        null,
	                        'Bovenstaande bedragen zijn inclusief 21% b.t.w.'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'div',
	            { className: 'card' },
	            _react2.default.createElement(
	                'div',
	                { className: 'card-content' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'content' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'WAT IS INBEGREPEN?'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'Als je bij ons een photobooth huurt dan is onderstaande standaard inbegrepen. Je kunt dit nog uitbreiden met opties bij de volgende stap.'
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = SideBar;
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _priceDisplay = __webpack_require__(123);
	
	var _priceDisplay2 = _interopRequireDefault(_priceDisplay);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Summary = function Summary(_ref) {
	    var event = _ref.event,
	        selectedOptions = _ref.selectedOptions,
	        userAddress = _ref.userAddress,
	        boothInfo = _ref.boothInfo,
	        basePrice = _ref.basePrice;
	
	    var months = ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december'];
	    var dateString = event.eventDate.getDate() + ' ' + months[event.eventDate.getMonth()] + ' ' + event.eventDate.getFullYear();
	    var totalPrice = selectedOptions.reduce(function (total, current) {
	        return total + current.price;
	    }, basePrice);
	
	    var renderOptions = function renderOptions() {
	        return selectedOptions.map(function (item) {
	            return item.title;
	        }).join(', ');
	    };
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'h4',
	            { className: 'step--active' },
	            'Stap 4: Bevestig en feest!'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Je huurt de ',
	            _react2.default.createElement(
	                'strong',
	                null,
	                boothInfo.name
	            ),
	            ' op ',
	            dateString,
	            '. De totaalprijs is ',
	            _react2.default.createElement(
	                'strong',
	                null,
	                _react2.default.createElement(_priceDisplay2.default, { price: totalPrice })
	            ),
	            ' incl. btw.'
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Je hebt ',
	            _react2.default.createElement(
	                'strong',
	                null,
	                selectedOptions.length > 0 ? selectedOptions.length : 'geen',
	                ' '
	            ),
	            selectedOptions.length === 1 ? 'optie' : 'opties',
	            ' gekozen',
	            selectedOptions.length > 0 ? ' (' + renderOptions() + ')' : null,
	            '.'
	        ),
	        userAddress && _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	                'span',
	                null,
	                'We sturen een bevestiging van deze reservering naar naar: ',
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    userAddress
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'p',
	            null,
	            'Kostenloze annulering van deze reservering is mogelijk tot 72 uur voor aanvang van evenement.'
	        )
	    );
	};
	
	exports.default = Summary;
	module.exports = exports['default'];

/***/ }),

/***/ 83:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var RECEIVED_ACCESS_TOKEN = exports.RECEIVED_ACCESS_TOKEN = 'receivedAccessToken';
	var RECEIVED_UNIT_LIST = exports.RECEIVED_UNIT_LIST = 'receivedUnitList';
	var RECEIVED_EVENT_LIST = exports.RECEIVED_EVENT_LIST = 'receivedEventList';
	var CHECKING_AVAILIBILITY = exports.CHECKING_AVAILIBILITY = 'checkingAvailibility';
	var PREPARE_BOOKING = exports.PREPARE_BOOKING = 'prepareBooking';
	var RESET_EVENT_BOOKING = exports.RESET_EVENT_BOOKING = 'resetEventBooking';

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var simplyBookApp = exports.simplyBookApp = 'gifture';
	var simplyBookPublicKey = exports.simplyBookPublicKey = '0a20f3546afc384b2a8f1f66a6aad31843674891524aaec575424b2cba7c5ea0';
	var publicMode = exports.publicMode = ("production") === 'production';

/***/ }),

/***/ 293:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var boothPricing = exports.boothPricing = {
	    1: 195,
	    2: 295,
	    3: 595
	};
	
	var orderOptions = exports.orderOptions = {
	    props: [{
	        image: '',
	        title: 'Standaard props',
	        description: 'Een setje met props die voor alle evenementen geschikt is',
	        price: 0,
	        selected: true
	    }, {
	        image: '',
	        title: 'Thema props',
	        description: 'Klik hier om een overzicht te krijgen van alle thema props',
	        price: 15
	    }, {
	        image: '',
	        title: 'Props op maat',
	        description: 'Laat unieke props door onze designer maken (3 stuks, max 20x20cm, 5mm forex) ',
	        price: 50
	    }, {
	        image: '',
	        title: 'Verkleedkist',
	        description: 'Een kist vol met pruiken, boa\'s, brillen en opblaasbare attributen',
	        price: 30
	    }],
	    backDrops: [{
	        image: '',
	        title: 'Witte achtergrond',
	        price: 20
	    }, {
	        image: '',
	        title: 'Gouden achtergrond',
	        price: 40
	    }, {
	        image: '',
	        title: 'Zilveren achtergrond',
	        price: 40
	    }],
	    templates: [{
	        image: '',
	        title: 'Standaard frame',
	        price: 0,
	        selected: true,
	        description: 'Keuze uit 20 templates, met eigen tekst'
	    }, {
	        image: '',
	        title: 'Op maat gemaakt frame',
	        price: 25,
	        description: 'Een op maat gemaakt frame in stijl van bijvoorbeeld de uitnodiging'
	    }],
	    expansion: [{
	        image: '',
	        title: 'Printen',
	        description: 'Laat uw gasten de gemaakte collages uitprinten! 500 printjes á 10x15 cm, 1000 printjes á 5x15 cm.',
	        price: 100
	    }, {
	        image: '',
	        title: 'Halen / Brengen buiten de regio',
	        description: 'We brengen, installeren en halen de photobooth. De photobooth wordt aan het begin van het evenement gebracht en aan het eind van het evenement weer gehaald.',
	        price: 100,
	        exlcudeFromDiscount: true
	    },
	    // {
	    //     image: '',
	    //     title: 'Zelf halen / terugbrengen',
	    //     description: 'Kom je zelf de photobooth halen en brengen? Je krijgt dan 15 euro korting op jouw boeking! Er wordt wel een borg in rekening gebracht.',
	    //     price: -15,
	    //     exlcudeFromDiscount: true
	    // },
	    {
	        image: '',
	        title: 'Website widget',
	        description: 'Met de Website widget kunt u foto\'s direct tonen op een eigen website',
	        price: 25
	    }, {
	        image: '',
	        title: 'Live upload',
	        description: 'Plaats foto\'s die gemaakt zijn direct op de eigen facebook pagina',
	        price: 50
	    }, {
	        image: '',
	        title: 'USB met foto\'s',
	        description: 'Ontvang na het event alle foto\'s op een luxe usb stick',
	        price: 25
	    }, {
	        image: '',
	        title: 'WIFI Hotspot',
	        description: 'Slecht wifi bereik op de locatie? We nemen graag een eigen hotspot mee!',
	        price: 0
	    }]
	};

/***/ }),

/***/ 300:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(22);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(46);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reservationForm = __webpack_require__(287);
	
	var _reservationForm2 = _interopRequireDefault(_reservationForm);
	
	var _christmasNotification = __webpack_require__(149);
	
	var _christmasNotification2 = _interopRequireDefault(_christmasNotification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reserveren = function Reserveren(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, {
	            title: 'Huur nu een photobooth v.a. \u20AC195 all in',
	            meta: [{
	                name: 'description',
	                content: 'Huur binnen 5 minuten een photbooth voor jouw evenement, trouwerij, bedrijfsborrel, jubileumfeest of ander feestje waar veel plezier gemaakt mag worden! All in prijzen vanaf \u20AC195,- per 24 uur! '
	            }, {
	                name: 'keywords',
	                content: ['photobooth', 'videobooth', 'gifbooth', 'fotobooth', 'fotohokje', 'bruiloft', 'gif photobooth', 'huren', 'lenen', 'trouwerij', 'evenement', 'feest', 'bedrijfsfeest', 'borrel', 'beurzen', 'beurs', 'verhuur'].join(',')
	            }]
	        }),
	        _react2.default.createElement(
	            'div',
	            { className: 'hero is-primary' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container has-text-centered' },
	                    _react2.default.createElement(
	                        'h1',
	                        { className: 'title' },
	                        'Reserveer een photobooth voor jouw feest of evenement'
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_reservationForm2.default, null)
	    );
	};
	
	exports.default = Reserveren;
	module.exports = exports['default'];

/***/ }),

/***/ 30:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.checkAvailability = exports.getUnits = exports.submitMessage = exports.makeBooking = exports.getEvents = exports.requestToken = undefined;
	
	var _axios = __webpack_require__(64);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _config = __webpack_require__(41);
	
	var config = _interopRequireWildcard(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var simplyBookServer = 'https://user-api.simplybook.me';
	var backendServer = _axios2.default.create({
	    baseURL: 'https://api.backand.com/1/',
	    timeout: 10000,
	    headers: {
	        'AnonymousToken': '57827708-cfca-4aa6-ab79-2e520aa6c75d',
	        'Content-Type': 'application/json'
	    }
	});
	var firebaseServer = _axios2.default.create({
	    baseURL: 'https://us-central1-gifturephotoboothapp.cloudfunctions.net/',
	    timeout: 10000
	});
	
	var accessToken = null;
	var axiosInstance = null;
	
	var requestToken = exports.requestToken = function requestToken() {
	    return new Promise(function (resolve, reject) {
	        _axios2.default.post(simplyBookServer + '/login', {
	            "jsonrpc": "2.0",
	            "method": "getToken",
	            "params": [config.simplyBookApp, config.simplyBookPublicKey],
	            "id": 1
	        }).then(function (response) {
	            if (response.status >= 200 && response.status <= 300) {
	                accessToken = response.data.result;
	                resolve(response.data.result);
	
	                axiosInstance = _axios2.default.create({
	                    baseURL: simplyBookServer,
	                    timeout: 3000,
	                    headers: {
	                        'X-Company-Login': config.simplyBookApp,
	                        'X-Token': accessToken,
	                        'Content-Type': 'application/json'
	                    }
	                });
	            } else {
	                reject();
	            }
	        });
	    });
	};
	
	var getEvents = exports.getEvents = function getEvents() {
	    return simplybookCall('getEventList');
	};
	
	var makeBooking = exports.makeBooking = function makeBooking(data) {
	    return firebaseServer.post('createBooking', {
	        boothName: data.boothName,
	        date: data.date,
	        options: data.options,
	        pricing: data.pricing,
	        customerName: data.customerName,
	        customerPhone: data.customerPhone,
	        customerAddress: data.customerAddress,
	        customerZip: data.customerZip,
	        customerCity: data.customerCity,
	        eventLocation: data.eventLocation,
	        eventStreet: data.eventStreet,
	        eventPostalCode: data.eventPostalCode,
	        eventCity: data.eventCity,
	        eventType: data.eventType,
	        message: data.message
	    });
	};
	
	var submitMessage = exports.submitMessage = function submitMessage(data) {
	    return firebaseServer.post('sendContact', {
	        firstName: data.firstName,
	        lastName: data.lastName,
	        emailAddress: data.emailAddress,
	        telephoneNumber: data.telephoneNumber,
	        message: data.message
	    });
	};
	
	var getUnits = exports.getUnits = function getUnits() {
	    return new Promise(function (resolve, reject) {
	        simplybookCall('getUnitList').then(function (response) {
	            resolve(response.data);
	        }).catch(function (error) {
	            reject();
	        });
	    });
	};
	
	var checkAvailability = exports.checkAvailability = function checkAvailability(props) {
	    var eventDate = new Date(props.eventDate);
	    return simplybookCall('getAvailableUnits', [props.eventId, eventDate.getFullYear() + '-' + (eventDate.getMonth() + 1) + '-' + eventDate.getDate() + ' 12:00:00']);
	};
	
	function simplybookCall() {
	    var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	    var id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	    return axiosInstance.post('/', {
	        "jsonrpc": "2.0",
	        "method": method,
	        "params": params,
	        "id": id
	    });
	}

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getUnits = getUnits;
	exports.makeBooking = makeBooking;
	exports.getEvents = getEvents;
	exports.prepareBooking = prepareBooking;
	exports.resetEvent = resetEvent;
	
	var _actionTypes = __webpack_require__(83);
	
	var types = _interopRequireWildcard(_actionTypes);
	
	var _simplyBookService = __webpack_require__(30);
	
	var SimplyBookServices = _interopRequireWildcard(_simplyBookService);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function requestToken(nextAction) {
	    if (!nextAction) {
	        console.warn('no valid next action');
	        return null;
	    }
	
	    return function (dispatch, getState) {
	        var currentState = getState();
	
	        if (!currentState.simplyBook.initiated) {
	            SimplyBookServices.requestToken().then(function (token) {
	                if (token) {
	                    dispatch(initiated());
	                    dispatch(nextAction());
	                } else {
	                    // TODO: Handle catch
	                }
	            }).catch(function (error) {
	                console.log('someting wong');
	            });
	        }
	    };
	}
	
	function initiated() {
	    return {
	        type: types.RECEIVED_ACCESS_TOKEN
	    };
	}
	
	function getUnits() {
	    return function (dispatch, getState) {
	        var currentState = getState();
	
	        if (!currentState.simplyBook.initiated) {
	            dispatch(requestToken(getUnits));
	            return null;
	        }
	
	        SimplyBookServices.getUnits().then(function (response) {
	            dispatch(receivedUnitList(response.result));
	        });
	    };
	}
	
	function makeBooking(data) {
	    return function (dispatch, getState) {};
	}
	
	function getEvents() {
	    return function (dispatch, getState) {
	        var currentState = getState();
	
	        if (!currentState.simplyBook.initiated) {
	            dispatch(requestToken(getEvents));
	            return null;
	        }
	
	        SimplyBookServices.getEvents().then(function (response) {
	            dispatch(receivedEventList(response.data.result));
	        });
	    };
	}
	
	function prepareBooking(availability, event) {
	    return {
	        type: types.PREPARE_BOOKING,
	        payload: {
	            availability: availability, event: event
	        }
	    };
	}
	
	function resetEvent() {
	    return {
	        type: types.RESET_EVENT_BOOKING
	    };
	}
	
	function receivedEventList(events) {
	    return {
	        type: types.RECEIVED_EVENT_LIST,
	        payload: {
	            events: events
	        }
	    };
	}
	
	function receivedUnitList(units) {
	    return {
	        type: types.RECEIVED_UNIT_LIST,
	        payload: {
	            units: units
	        }
	    };
	}

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reserveren-js-bad050edc561f5e73004.js